// import React, { useContext, useEffect, useState } from "react";
// import axios from "axios";
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import { toast } from "react-toastify";
// import { FaPlus } from "react-icons/fa";

// export default function AttendanceCalendar() {
//   const { user: currentUser } = useContext(AuthContext);
//   const [attendanceData, setAttendanceData] = useState([]);
//   const [leaveData, setLeaveData] = useState([]);
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [todayAttendance, setTodayAttendance] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [users, setUsers] = useState([]);
//   const [selectedUserId, setSelectedUserId] = useState(null);
//   const [showLeaveModal, setShowLeaveModal] = useState(false);
//   const [leaveForm, setLeaveForm] = useState({
//     userId: currentUser?.id,
//     leaveType: "CASUAL",
//     fromDate: new Date().toISOString().split('T')[0],
//     toDate: new Date().toISOString().split('T')[0],
//     reason: ""
//   });

//   const token = localStorage.getItem("token");
//   const headers = { Authorization: `Bearer ${token}` };

//   // Leave types with colors for calendar display
//   const leaveTypes = {
//     CASUAL: { color: "#3b82f6", textColor: "#ffffff" }, // blue
//     SICK: { color: "#DC7633", textColor: "#ffffff" }, // red
//     EARNED: { color: "#5D6D7E", textColor: "#ffffff" }, // green
//     MATERNITY: { color: "#8b5cf6", textColor: "#ffffff" }, // purple
//     PATERNITY: { color: "#ec4899", textColor: "#ffffff" }, // pink
//     OTHER: { color: "#F1C40F", textColor: "#ffffff" } // yellow
//   };

//   // Status colors
//   const statusColors = {
//     PRESENT: { color: "#10b981", textColor: "#ffffff" }, // green
//     ABSENT: { color: "#ef4444", textColor: "#ffffff" }, // red
//     HALF_DAY: { color: "#f59e0b", textColor: "#ffffff" } // yellow
//   };

//   // Fetch users based on account type
//   useEffect(() => {
//     async function fetchUsers() {
//       if (!currentUser?.id || !currentUser?.accountType) return;

//       const url =
//         currentUser.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${currentUser.id}&accountType=${currentUser.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${currentUser.id}&accountType=${currentUser.accountType}`;

//       try {
//         const response = await fetch(url, {
//           method: "GET",
//           headers: {
//             authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const data = await response.json();
//         setUsers(data);
        
//         // Set the current user as default selected
//         if (data.length > 0) {
//           setSelectedUserId(currentUser.id);
//         }
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }

//     fetchUsers();
//   }, [currentUser, token]);

//   // Fetch attendance data when selected user changes
//   const fetchAttendanceData = async (userId) => {
//     if (!token || !userId) return;
//     try {
//       const res = await axios.get(`${API_URL}/api/attendance/user/${userId}`, {
//         headers,
//       });
//       setAttendanceData(res.data || []);
//     } catch (err) {
//       console.error("Error fetching attendance data:", err);
//     }
//   };

//   // Fetch leave data when selected user changes
//   const fetchLeaveData = async (userId) => {
//     if (!token || !userId) return;
//     try {
//       const res = await axios.get(`${API_URL}/api/leave/user/${userId}`, {
//         headers,
//       });
//       setLeaveData(res.data || []);
//     } catch (err) {
//       console.error("Error fetching leave data:", err);
//     }
//   };

//   // Check today's attendance for the selected user
//   const checkTodayAttendance = async (userId) => {
//     if (!token || !userId) return;
//     setIsLoading(true);
//     try {
//       const today = new Date().toISOString().split('T')[0];
//       const res = await axios.get(`${API_URL}/api/attendance/user/${userId}`, {
//         headers,
//       });
      
//       // Find today's attendance record
//       const todayRecord = res.data.find(item => {
//         const itemDate = new Date(item.date).toISOString().split('T')[0];
//         return itemDate === today;
//       });
      
//       setTodayAttendance(todayRecord || null);
//     } catch (err) {
//       console.error("Error checking today's attendance:", err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (selectedUserId) {
//       fetchAttendanceData(selectedUserId);
//       fetchLeaveData(selectedUserId);
//       checkTodayAttendance(selectedUserId);
//     }
//   }, [selectedUserId]);

//   const handleCheckIn = async () => {
//     if (!token || !selectedUserId) return;
//     setIsLoading(true);
//     try {
//       await axios.post(`${API_URL}/api/attendance/checkin/${selectedUserId}`, {}, { headers });
//       toast.success("Checked in successfully");
//       await checkTodayAttendance(selectedUserId);
//       await fetchAttendanceData(selectedUserId);
//     } catch (err) {
//       toast.error("Failed to check in");
//       console.error(err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleCheckOut = async () => {
//     if (!token || !selectedUserId) return;
//     setIsLoading(true);
//     try {
//       await axios.post(`${API_URL}/api/attendance/checkout/${selectedUserId}`, {}, { headers });
//       toast.success("Checked out successfully");
//       await checkTodayAttendance(selectedUserId);
//       await fetchAttendanceData(selectedUserId);
//     } catch (err) {
//       toast.error("Failed to check out");
//       console.error(err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleLeaveSubmit = async (e) => {
//     e.preventDefault();
//     if (!token) return;
//     setIsLoading(true);
//     try {
//       await axios.post(`${API_URL}/api/leave/apply`, leaveForm, { headers });
//       toast.success("Leave applied successfully");
//       setShowLeaveModal(false);
//       await fetchLeaveData(selectedUserId);
//       setLeaveForm({
//         leaveType: "CASUAL",
//         fromDate: new Date().toISOString().split('T')[0],
//         toDate: new Date().toISOString().split('T')[0],
//         reason: ""
//       });
//     } catch (err) {
//       toast.error("Failed to apply leave");
//       console.error(err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleLeaveFormChange = (e) => {
//     const { name, value } = e.target;
//     setLeaveForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   // Get all attendance dates with status for the selected user
//   const getAttendanceDates = () => {
//     return attendanceData.map(item => ({
//       date: new Date(item.date).toDateString(),
//       status: item.status
//     }));
//   };

//   const attendanceDates = getAttendanceDates();

//   // Get all leave dates for the selected user
//   const getLeaveDates = () => {
//     const leaveDates = [];
//     leaveData.forEach(leave => {
//       const fromDate = new Date(leave.fromDate);
//       const toDate = new Date(leave.toDate);
      
//       // Add all dates in the leave range
//       for (let date = new Date(fromDate); date <= toDate; date.setDate(date.getDate() + 1)) {
//         leaveDates.push({
//           date: new Date(date).toDateString(),
//           type: leave.leaveType
//         });
//       }
//     });
//     return leaveDates;
//   };

//   const leaveDates = getLeaveDates();

//   const filteredAttendance = attendanceData.filter((item) => {
//     return new Date(item.date).toDateString() === selectedDate.toDateString();
//   });

//   const filteredLeaves = leaveData.filter(leave => {
//     const fromDate = new Date(leave.fromDate);
//     const toDate = new Date(leave.toDate);
//     const selected = new Date(selectedDate);
//     return selected >= fromDate && selected <= toDate;
//   });

//   const formatTime = (dateString) => {
//     if (!dateString) return "_";
//     const date = new Date(dateString);
//     return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//   };

//   const formatDuration = (checkIn, checkOut) => {
//     if (!checkIn || !checkOut) return "_";
    
//     const start = new Date(checkIn);
//     const end = new Date(checkOut);
//     const diff = Math.abs(end - start);
    
//     const hours = Math.floor(diff / (1000 * 60 * 60));
//     const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    
//     return `${hours}h ${minutes}m`;
//   };

//   const handleUserChange = (e) => {
//     const userId = e.target.value;
//     setSelectedUserId(userId);
//   };

//   const getSelectedUserName = () => {
//     if (!selectedUserId) return "";
//     const selectedUser = users.find(u => u.id === selectedUserId);
//     return selectedUser ? `${selectedUser.fname} ${selectedUser.lname}` : "";
//   };

//   // Custom tile content for calendar to show leave and status indicators
//   const tileContent = ({ date, view }) => {
//   if (view !== 'month') return null;
  
//   const dateStr = date.toDateString();
//   const leaveOnDate = leaveDates.find(d => d.date === dateStr);
//   const attendanceOnDate = attendanceDates.find(d => d.date === dateStr);
  
//   // Create a small indicator for the corner
//   const indicatorStyle = {
//     position: 'absolute',
//     top: '5px',
//     right: '5px',
//     width: '16px',
//     height: '16px',
//     borderRadius: '50%',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontSize: '10px',
//     fontWeight: 'bold'
//   };

//   if (!leaveOnDate && attendanceOnDate) {
//     const status = attendanceOnDate.status;
//     return (
//       <div 
//         style={{
//           ...indicatorStyle,
//           backgroundColor: statusColors[status]?.color,
//           color: statusColors[status]?.textColor
//         }}
//       >
//         {status.charAt(0)}
//       </div>
//     );
//   }
  
//   if (leaveOnDate) {
//     return (
//       <div 
//         style={{
//           ...indicatorStyle,
//           backgroundColor: leaveTypes[leaveOnDate.type]?.color,
//           color: leaveTypes[leaveOnDate.type]?.textColor
//         }}
//       >
//         {leaveOnDate.type.charAt(0)}
//       </div>
//     );
//   }
  
//   return null;
// };

//   return (
//     <div className="w-full min-h-screen bg-gray-100 p-4 md:p-8 dark:bg-gray-900 dark:text-white shadow-lg">
//       <div className="max-w-7xl mx-auto space-y-6">
// <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
//   <h1 className="text-3xl font-bold text-gray-800 dark:text-white">
//     📅 Attendance & Leave Calendar
//   </h1>
//   {selectedUserId === currentUser?.id && (
//     <div className="flex gap-2">
//       {/* Leave Application Button */}
//       <button
//         onClick={() => setShowLeaveModal(true)}
//         className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-full shadow-md transition-transform transform hover:scale-105"
//       >
//         <FaPlus /> Apply Leave
//       </button>
      
//       {todayAttendance?.checkInTime && !todayAttendance?.checkOutTime ? (
//         <button
//           onClick={handleCheckOut}
//           disabled={isLoading}
//           className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-5 py-2 rounded-full shadow-md transition-transform transform hover:scale-105 disabled:opacity-50"
//         >
//           {isLoading ? "Processing..." : "Check Out"}
//         </button>
//       ) : (
//         <button
//           onClick={handleCheckIn}
//           disabled={isLoading || (todayAttendance?.checkInTime && todayAttendance?.checkOutTime)}
//           className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-full shadow-md transition-transform transform hover:scale-105 disabled:opacity-50"
//         >
//           {isLoading ? "Processing..." : 
//             (todayAttendance?.checkInTime && todayAttendance?.checkOutTime) ? 
//             "Already Checked Out" : "Check In"}
//         </button>
//       )}
//     </div>
//   )}
// </div>

// {currentUser?.accountType !== "EXECUTIVE" && (
//   <div className="bg-white/50 backdrop-blur-xl rounded-2xl shadow-lg p-4 sm:p-6 dark:bg-gray-800 dark:text-white">
//     <div className="mb-4">
//       <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
//         Select User
//       </label>
//       <select
//         value={selectedUserId || ""}
//         onChange={handleUserChange}
//         className="w-full p-2 border rounded-md dark:bg-gray-700 dark:text-white dark:border-gray-600"
//       >
//         <option value="">Select User</option>
//         {users.map((user) => (
//           <option key={user.id} value={user.id}>
//             {user.fname} {user.lname}
//           </option>
//         ))}
//       </select>
//     </div>
//     {selectedUserId && (
//       <div className="text-lg font-semibold">
//         Viewing records for: <span className="text-blue-600">{getSelectedUserName()}</span>
//       </div>
//     )}
//   </div>
// )}

//         <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-6">
//           {/* Calendar Section */}
//           <div className="bg-white/50 backdrop-blur-xl rounded-2xl shadow-lg p-4 sm:p-6 dark:bg-gray-800 dark:text-white">
//             <h2 className="text-lg sm:text-xl font-semibold text-gray-700 mb-4 text-center dark:text-white">
//               Pick a Date
//             </h2>
//             <div className="flex justify-center">
//               <Calendar
//                 onChange={setSelectedDate}
//                 value={selectedDate}
//                 className="calendar-custom dark:bg-gray-900 dark:text-white"
//                 tileClassName={({ date, view }) => {
//                   if (view !== "month") return "";
                  
//                   const dateStr = date.toDateString();
//                   const leaveOnDate = leaveDates.find(d => d.date === dateStr);
//                   const attendanceOnDate = attendanceDates.find(d => d.date === dateStr);
                  
//                   if (leaveOnDate) {
//                     return `highlighted-leave-${leaveOnDate.type.toLowerCase()}`;
//                   }
                  
//                   if (attendanceOnDate) {
//                     return `highlighted-status-${attendanceOnDate.status.toLowerCase()}`;
//                   }
                  
//                   return "";
//                 }}
//                 tileContent={tileContent}
//               />
//             </div>
            
//             {/* Status and Leave Legend */}
//             <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
//               <div>
//                 <h3 className="text-sm font-semibold text-gray-700 mb-2 dark:text-gray-300">Status Legend</h3>
//                 <div className="grid grid-cols-2 gap-2">
//                   {Object.entries(statusColors).map(([status, { color }]) => (
//                     <div key={status} className="flex items-center">
//                       <div 
//                         className="w-4 h-4 rounded-full mr-2" 
//                         style={{ backgroundColor: color }}
//                       ></div>
//                       <span className="text-xs">{status}</span>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div>
//                 <h3 className="text-sm font-semibold text-gray-700 mb-2 dark:text-gray-300">Leave Legend</h3>
//                 <div className="grid grid-cols-2 gap-2">
//                   {Object.entries(leaveTypes).map(([type, { color }]) => (
//                     <div key={type} className="flex items-center">
//                       <div 
//                         className="w-4 h-4 rounded-full mr-2" 
//                         style={{ backgroundColor: color }}
//                       ></div>
//                       <span className="text-xs">{type}</span>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Records Section */}
//           <div className="bg-white/50 backdrop-blur-xl rounded-2xl shadow-lg p-4 sm:p-6 dark:bg-gray-800 dark:text-white">
//             <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-4 dark:text-white">
//               Records on{" "}
//               <span className="text-blue-700 dark:text-blue-400">
//                 {selectedDate.toDateString()}
//               </span>
//             </h2>

//             {/* Attendance Records */}
//             <div className="mb-6">
//               <h3 className="text-md font-semibold text-gray-700 mb-2 dark:text-gray-300">Attendance</h3>
//               {filteredAttendance.length > 0 ? (
//                 <ul className="space-y-4 max-h-[250px] overflow-y-auto custom-scrollbar pr-2">
//                   {filteredAttendance.map((item, index) => (
//                     <li
//                       key={item.id || index}
//                       className="p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition flex flex-col gap-2 border border-gray-200 dark:bg-gray-900 dark:text-white"
//                     >
//                       <div className="flex justify-between items-start">
//                         <div>
//                           <h3 className="text-sm font-semibold text-gray-500">Status</h3>
//                           <p 
//                             className="text-lg font-bold capitalize"
//                             style={{ color: statusColors[item.status]?.color }}
//                           >
//                             {item.status.toLowerCase()}
//                           </p>
//                         </div>
//                         {item.status === 'PRESENT' && (
//                           <div className="grid grid-cols-2 gap-4">
//                             <div>
//                               <h3 className="text-sm font-semibold text-gray-500">Check In</h3>
//                               <p className="text-lg font-bold">
//                                 {formatTime(item.checkInTime)}
//                               </p>
//                             </div>
//                             <div>
//                               <h3 className="text-sm font-semibold text-gray-500">Check Out</h3>
//                               <p className="text-lg font-bold">
//                                 {item.checkOutTime ? formatTime(item.checkOutTime) : "Not checked out"}
//                               </p>
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                       {item.status === 'PRESENT' && (
//                         <div className="mt-2">
//                           <h3 className="text-sm font-semibold text-gray-500">Duration</h3>
//                           <p className="text-lg font-bold">
//                             {formatDuration(item.checkInTime, item.checkOutTime)}
//                           </p>
//                         </div>
//                       )}
//                     </li>
//                   ))}
//                 </ul>
//               ) : (
//                 <p className="text-gray-600 italic">No attendance records for this date.</p>
//               )}
//             </div>

//             {/* Leave Records */}
//             <div>
//               <h3 className="text-md font-semibold text-gray-700 mb-2 dark:text-gray-300">Leave</h3>
//               {filteredLeaves.length > 0 ? (
//                 <ul className="space-y-4 max-h-[250px] overflow-y-auto custom-scrollbar pr-2">
//                   {filteredLeaves.map((leave, index) => (
//                     <li
//                       key={leave.id || index}
//                       className="p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition flex flex-col gap-2 border border-gray-200 dark:bg-gray-900 dark:text-white"
//                       style={{
//                         borderLeft: `4px solid ${leaveTypes[leave.leaveType]?.color || '#999'}`
//                       }}
//                     >
//                       <div className="grid grid-cols-2 gap-4">
//                         <div>
//                           <h3 className="text-sm font-semibold text-gray-500">From</h3>
//                           <p className="text-lg font-bold">
//                             {new Date(leave.fromDate).toLocaleDateString()}
//                           </p>
//                         </div>
//                         <div>
//                           <h3 className="text-sm font-semibold text-gray-500">To</h3>
//                           <p className="text-lg font-bold">
//                             {new Date(leave.toDate).toLocaleDateString()}
//                           </p>
//                         </div>
//                       </div>
//                       <div className="mt-2">
//                         <h3 className="text-sm font-semibold text-gray-500">Type</h3>
//                         <p className="text-lg font-bold capitalize" style={{ color: leaveTypes[leave.leaveType]?.color }}>
//                           {leave.leaveType.toLowerCase()}
//                         </p>
//                       </div>
//                       {leave.reason && (
//                         <div className="mt-2">
//                           <h3 className="text-sm font-semibold text-gray-500">Reason</h3>
//                           <p className="text-sm">{leave.reason}</p>
//                         </div>
//                       )}
//                     </li>
//                   ))}
//                 </ul>
//               ) : (
//                 <p className="text-gray-600 italic">No leave records for this date.</p>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Leave Application Modal */}
//       {showLeaveModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-xl shadow-2xl w-full max-w-md dark:bg-gray-800">
//             <div className="p-6">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-xl font-bold text-gray-800 dark:text-white">Apply for Leave</h2>
//                 <button 
//                   onClick={() => setShowLeaveModal(false)}
//                   className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
//                 >
//                   ✕
//                 </button>
//               </div>
              
//               <form onSubmit={handleLeaveSubmit}>
//                 <div className="space-y-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       Leave Type
//                     </label>
//                     <select
//                       name="leaveType"
//                       value={leaveForm.leaveType}
//                       onChange={handleLeaveFormChange}
//                       className="w-full p-2 border rounded-md dark:bg-gray-700 dark:text-white dark:border-gray-600"
//                       required
//                     >
//                       {Object.keys(leaveTypes).map(type => (
//                         <option key={type} value={type}>{type}</option>
//                       ))}
//                     </select>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       From Date
//                     </label>
//                     <input
//                       type="date"
//                       name="fromDate"
//                       value={leaveForm.fromDate}
//                       onChange={handleLeaveFormChange}
//                       className="w-full p-2 border rounded-md dark:bg-gray-700 dark:text-white dark:border-gray-600"
//                       required
//                       min={new Date().toISOString().split('T')[0]}
//                     />
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       To Date
//                     </label>
//                     <input
//                       type="date"
//                       name="toDate"
//                       value={leaveForm.toDate}
//                       onChange={handleLeaveFormChange}
//                       className="w-full p-2 border rounded-md dark:bg-gray-700 dark:text-white dark:border-gray-600"
//                       required
//                       min={leaveForm.fromDate}
//                     />
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
//                       Reason
//                     </label>
//                     <textarea
//                       name="reason"
//                       value={leaveForm.reason}
//                       onChange={handleLeaveFormChange}
//                       rows={3}
//                       className="w-full p-2 border rounded-md dark:bg-gray-700 dark:text-white dark:border-gray-600"
//                       required
//                     />
//                   </div>
//                 </div>
                
//                 <div className="mt-6 flex justify-end space-x-3">
//                   <button
//                     type="button"
//                     onClick={() => setShowLeaveModal(false)}
//                     className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 dark:bg-gray-600 dark:text-white"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     disabled={isLoading}
//                     className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700 disabled:opacity-50"
//                   >
//                     {isLoading ? "Submitting..." : "Submit Leave"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Custom Styles */}
//       <style jsx="true">{`
//         .react-calendar {
//           width: 100%;
//           max-width: 500px;
//           background-color: white;
//           border: none;
//           border-radius: 1rem;
//           padding: 1rem;
//           font-family: inherit;
//         }
//         .dark .react-calendar {
//           background-color: #1f2937;
//           color: white;
//         }
//         .react-calendar__navigation {
//           margin-bottom: 1rem;
//         }
//         .react-calendar__tile {
//           padding: 1rem 0.5rem;
//           position: relative;
//         }
//         .react-calendar__tile--active {
//           background: #6366f1 !important;
//           color: white !important;
//           border-radius: 9999px !important;
//           font-weight: bold;
//         }
//         .dark .react-calendar__tile:enabled:hover,
//         .dark .react-calendar__tile:enabled:focus {
//           background-color: #374151;
//         }
        
//         /* Status highlight classes */
//         .highlighted-status-present {
//           background-color: #dcfce7 !important;
//           color: #166534 !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
//         .highlighted-status-absent {
//           background-color: #fee2e2 !important;
//           color: #991b1b !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
//         .highlighted-status-half_day {
//           background-color: #fef3c7 !important;
//           color: #92400e !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
        
//         /* Leave highlight classes */
//         .highlighted-leave-casual {
//           background-color: #dbeafe !important;
//           color: #1e40af !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
//         .highlighted-leave-sick {
//           background-color: #fee2e2 !important;
//           color: #991b1b !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
//         .highlighted-leave-earned {
//           background-color: #dcfce7 !important;
//           color: #166534 !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
//         .highlighted-leave-maternity {
//           background-color: #ede9fe !important;
//           color: #5b21b6 !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
//         .highlighted-leave-paternity {
//           background-color: #fce7f3 !important;
//           color: #9d174d !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
//         .highlighted-leave-other {
//           background-color: #fef3c7 !important;
//           color: #92400e !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
        
//         /* Dark mode styles */
//         .dark .highlighted-status-present {
//           background-color: #166534 !important;
//           color: #dcfce7 !important;
//         }
//         .dark .highlighted-status-absent {
//           background-color: #991b1b !important;
//           color: #fee2e2 !important;
//         }
//         .dark .highlighted-status-half_day {
//           background-color: #92400e !important;
//           color: #fef3c7 !important;
//         }
        
//         .dark .highlighted-leave-casual {
//           background-color: #1e40af !important;
//           color: #dbeafe !important;
//         }
//         .dark .highlighted-leave-sick {
//           background-color: #991b1b !important;
//           color: #fee2e2 !important;
//         }
//         .dark .highlighted-leave-earned {
//           background-color: #166534 !important;
//           color: #dcfce7 !important;
//         }
//         .dark .highlighted-leave-maternity {
//           background-color: #5b21b6 !important;
//           color: #ede9fe !important;
//         }
//         .dark .highlighted-leave-paternity {
//           background-color: #9d174d !important;
//           color: #fce7f3 !important;
//         }
//         .dark .highlighted-leave-other {
//           background-color: #92400e !important;
//           color: #fef3c7 !important;
//         }
//       `}</style>
//     </div>
//   );
// }



// import React, { useContext, useEffect, useState } from "react";
// import { FaEnvelope, FaPlusCircle, FaTrash, FaPlus, FaTimes, FaEdit } from "react-icons/fa";
// import axios from "axios";
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import { toast } from "react-toastify";

// export default function EventCalendar() {
//   const { user: currentUser } = useContext(AuthContext);
//   const [attendanceData, setAttendanceData] = useState([]);
//   const [leaveData, setLeaveData] = useState([]);
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const [todayAttendance, setTodayAttendance] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [users, setUsers] = useState([]);
//   const [selectedUserId, setSelectedUserId] = useState(null);
//   const [showLeaveModal, setShowLeaveModal] = useState(false);
//   const [leaveForm, setLeaveForm] = useState({
//     userId: currentUser?.id,
//     leaveType: "CASUAL",
//     fromDate: new Date().toISOString().split('T')[0],
//     toDate: new Date().toISOString().split('T')[0],
//     reason: ""
//   });

//   const token = localStorage.getItem("token");
//   const headers = { Authorization: `Bearer ${token}` };

//   // Leave types with colors for calendar display
//   const leaveTypes = {
//     CASUAL: { color: "#3b82f6", textColor: "#ffffff" }, // blue
//     SICK: { color: "#DC7633", textColor: "#ffffff" }, // orange/red
//     EARNED: { color: "#5D6D7E", textColor: "#ffffff" }, // grey
//     MATERNITY: { color: "#8b5cf6", textColor: "#ffffff" }, // purple
//     PATERNITY: { color: "#ec4899", textColor: "#ffffff" }, // pink
//     OTHER: { color: "#F1C40F", textColor: "#ffffff" } // yellow
//   };

//   // Status colors
//   const statusColors = {
//     PRESENT: { color: "#10b981", textColor: "#ffffff" }, // green
//     ABSENT: { color: "#ef4444", textColor: "#ffffff" }, // red
//     HALF_DAY: { color: "#f59e0b", textColor: "#ffffff" } // yellow
//   };

//   // Fetch users based on account type
//   useEffect(() => {
//     async function fetchUsers() {
//       if (!currentUser?.id || !currentUser?.accountType) return;

//       const url =
//         currentUser.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${currentUser.id}&accountType=${currentUser.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${currentUser.id}&accountType=${currentUser.accountType}`;

//       try {
//         const response = await fetch(url, {
//           method: "GET",
//           headers: {
//             authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const data = await response.json();
//         setUsers(data);
        
//         // Set the current user as default selected
//         if (data.length > 0) {
//           setSelectedUserId(currentUser.id);
//         }
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }

//     fetchUsers();
//   }, [currentUser, token]);

//   // Fetch attendance data when selected user changes
//   const fetchAttendanceData = async (userId) => {
//     if (!token || !userId) return;
//     try {
//       const res = await axios.get(`${API_URL}/api/attendance/user/${userId}`, {
//         headers,
//       });
//       setAttendanceData(res.data || []);
//     } catch (err) {
//       console.error("Error fetching attendance data:", err);
//     }
//   };

//   // Fetch leave data when selected user changes
//   const fetchLeaveData = async (userId) => {
//     if (!token || !userId) return;
//     try {
//       const res = await axios.get(`${API_URL}/api/leave/user/${userId}`, {
//         headers,
//       });
//       setLeaveData(res.data || []);
//     } catch (err) {
//       console.error("Error fetching leave data:", err);
//     }
//   };

//   // Check today's attendance for the selected user
//   const checkTodayAttendance = async (userId) => {
//     if (!token || !userId) return;
//     setIsLoading(true);
//     try {
//       const today = new Date().toISOString().split('T')[0];
//       const res = await axios.get(`${API_URL}/api/attendance/user/${userId}`, {
//         headers,
//       });
      
//       // Find today's attendance record
//       const todayRecord = res.data.find(item => {
//         const itemDate = new Date(item.date).toISOString().split('T')[0];
//         return itemDate === today;
//       });
      
//       setTodayAttendance(todayRecord || null);
//     } catch (err) {
//       console.error("Error checking today's attendance:", err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (selectedUserId) {
//       fetchAttendanceData(selectedUserId);
//       fetchLeaveData(selectedUserId);
//       checkTodayAttendance(selectedUserId);
//     }
//   }, [selectedUserId]);

//   const handleCheckIn = async () => {
//     if (!token || !selectedUserId) return;
//     setIsLoading(true);
//     try {
//       await axios.post(`${API_URL}/api/attendance/checkin/${selectedUserId}`, {}, { headers });
//       toast.success("Checked in successfully");
//       await checkTodayAttendance(selectedUserId);
//       await fetchAttendanceData(selectedUserId);
//     } catch (err) {
//       toast.error("Failed to check in");
//       console.error(err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleCheckOut = async () => {
//     if (!token || !selectedUserId) return;
//     setIsLoading(true);
//     try {
//       await axios.post(`${API_URL}/api/attendance/checkout/${selectedUserId}`, {}, { headers });
//       toast.success("Checked out successfully");
//       await checkTodayAttendance(selectedUserId);
//       await fetchAttendanceData(selectedUserId);
//     } catch (err) {
//       toast.error("Failed to check out");
//       console.error(err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleLeaveSubmit = async (e) => {
//     e.preventDefault();
//     if (!token) return;
//     setIsLoading(true);
//     try {
//       await axios.post(`${API_URL}/api/leave/apply`, leaveForm, { headers });
//       toast.success("Leave applied successfully");
//       setShowLeaveModal(false);
//       await fetchLeaveData(selectedUserId);
//       setLeaveForm({
//         leaveType: "CASUAL",
//         fromDate: new Date().toISOString().split('T')[0],
//         toDate: new Date().toISOString().split('T')[0],
//         reason: ""
//       });
//     } catch (err) {
//       toast.error("Failed to apply leave");
//       console.error(err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleLeaveFormChange = (e) => {
//     const { name, value } = e.target;
//     setLeaveForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   // Get all attendance dates with status for the selected user
//   const getAttendanceDates = () => {
//     return attendanceData.map(item => ({
//       date: new Date(item.date).toDateString(),
//       status: item.status
//     }));
//   };

//   const attendanceDates = getAttendanceDates();

//   // Get all leave dates for the selected user
//   const getLeaveDates = () => {
//     const leaveDates = [];
//     leaveData.forEach(leave => {
//       const fromDate = new Date(leave.fromDate);
//       const toDate = new Date(leave.toDate);
      
//       // Add all dates in the leave range
//       for (let date = new Date(fromDate); date <= toDate; date.setDate(date.getDate() + 1)) {
//         leaveDates.push({
//           date: new Date(date).toDateString(),
//           type: leave.leaveType
//         });
//       }
//     });
//     return leaveDates;
//   };

//   const leaveDates = getLeaveDates();

//   const filteredAttendance = attendanceData.filter((item) => {
//     return new Date(item.date).toDateString() === selectedDate.toDateString();
//   });

//   const filteredLeaves = leaveData.filter(leave => {
//     const fromDate = new Date(leave.fromDate);
//     const toDate = new Date(leave.toDate);
//     const selected = new Date(selectedDate);
//     return selected >= fromDate && selected <= toDate;
//   });

//   const formatTime = (dateString) => {
//     if (!dateString) return "_";
//     const date = new Date(dateString);
//     return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//   };

//   const formatDuration = (checkIn, checkOut) => {
//     if (!checkIn || !checkOut) return "_";
    
//     const start = new Date(checkIn);
//     const end = new Date(checkOut);
//     const diff = Math.abs(end - start);
    
//     const hours = Math.floor(diff / (1000 * 60 * 60));
//     const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    
//     return `${hours}h ${minutes}m`;
//   };

//   const handleUserChange = (e) => {
//     const userId = e.target.value;
//     setSelectedUserId(userId);
//   };

//   const getSelectedUserName = () => {
//     if (!selectedUserId) return "";
//     const selectedUser = users.find(u => u.id === selectedUserId);
//     return selectedUser ? `${selectedUser.fname} ${selectedUser.lname}` : "";
//   };

//   // Custom tile content for calendar to show leave and status indicators
//   const tileContent = ({ date, view }) => {
//     if (view !== 'month') return null;
    
//     const dateStr = date.toDateString();
//     const leaveOnDate = leaveDates.find(d => d.date === dateStr);
//     const attendanceOnDate = attendanceDates.find(d => d.date === dateStr);
    
//     // Create a small indicator for the corner
//     const indicatorStyle = {
//       position: 'absolute',
//       top: '5px',
//       right: '5px',
//       width: '16px',
//       height: '16px',
//       borderRadius: '50%',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       fontSize: '10px',
//       fontWeight: 'bold'
//     };

//     if (!leaveOnDate && attendanceOnDate) {
//       const status = attendanceOnDate.status;
//       return (
//         <div 
//           style={{
//             ...indicatorStyle,
//             backgroundColor: statusColors[status]?.color,
//             color: statusColors[status]?.textColor
//           }}
//         >
//           {status.charAt(0)}
//         </div>
//       );
//     }
    
//     if (leaveOnDate) {
//       return (
//         <div 
//           style={{
//             ...indicatorStyle,
//             backgroundColor: leaveTypes[leaveOnDate.type]?.color,
//             color: leaveTypes[leaveOnDate.type]?.textColor
//           }}
//         >
//           {leaveOnDate.type.charAt(0)}
//         </div>
//       );
//     }
    
//     return null;
//   };

//   // Original events fetching for the calendar component
//   const [events, setEvents] = useState([]);
//   const [deleteConfirm, setDeleteConfirm] = useState({ show: false, eventId: null });
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [eventFormData, setEventFormData] = useState({
//     title: "",
//     description: "",
//     date: "",
//     ignoreYear: false,
//     public: false,
//     time: "",
//     createdById: "",
//     createdByName: "",
//     companyId: "",
//     emails: [],
//   });
//   const [showEventModal, setShowEventModal] = useState(false);
//   const [showEmailModal, setShowEmailModal] = useState(false);
//   const [emails, setEmails] = useState([""]);
//   const [selectedEventIdForEmail, setSelectedEventIdForEmail] = useState(null);
//   const [selectedEventForEmail, setSelectedEventForEmail] = useState(null);
//   const [emailErrors, setEmailErrors] = useState([]);
//   const [activeStartDate, setActiveStartDate] = useState(new Date());
//   const [calendarData, setCalendarData] = useState({
//     events: [],
//     eventsByDate: {},
//     totalEvents: 0,
//   });
//   const [calendarLoading, setCalendarLoading] = useState(false);

//   const fetchEvents = async () => {
//     if (!token || !currentUser) return;
//     try {
//       const res =
//         currentUser.accountType === "COMPANY"
//           ? await axios.get(`${API_URL}/api/events/company/${currentUser.id}`, { headers })
//           : await axios.get(`${API_URL}/api/events/company/${currentUser.companyId}/createdBy/${currentUser.id}`, { headers });
//       setEvents(res.data.events || []);
//     } catch (err) {
//       console.error("Error fetching events:", err);
//     }
//   };

//   useEffect(() => {
//     if (!currentUser) return;
//     setEventFormData((prev) => ({
//       ...prev,
//       createdById: currentUser?.id,
//       createdByName: currentUser?.name,
//       companyId: currentUser?.accountType === "COMPANY" ? currentUser?.id : currentUser?.companyId,
//     }));
//     fetchEvents();
//   }, [currentUser]);

//   const fetchCalendarMonth = async (date) => {
//     if (!token || !currentUser) return;
//     try {
//       setCalendarLoading(true);
//       const companyId = currentUser.accountType === "COMPANY" ? currentUser.id : currentUser.companyId;
//       const year = date.getFullYear();
//       const month = date.getMonth() + 1;
//       const res = await axios.get(
//         `${API_URL}/api/calendar/month/${companyId}?year=${year}&month=${month}&userId=${currentUser.id}`,
//         { headers }
//       );
//       setCalendarData({
//         events: res.data?.events || [],
//         eventsByDate: res.data?.eventsByDate || {},
//         totalEvents: res.data?.totalEvents || 0,
//       });
//     } catch (err) {
//       console.error("Error fetching calendar data:", err);
//       setCalendarData({ events: [], eventsByDate: {}, totalEvents: 0 });
//     } finally {
//       setCalendarLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!currentUser) return;
//     fetchCalendarMonth(activeStartDate);
//   }, [currentUser, activeStartDate]);

//   const selectedDateKey = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, "0")}-${String(selectedDate.getDate()).padStart(2, "0")}`;
//   const activitiesForSelectedDate = calendarData.eventsByDate?.[selectedDateKey] || [];
//   const calendarHighlightDates = Object.keys(calendarData.eventsByDate || {}).map((d) => new Date(d).toDateString());

//   const handleEventSubmit = async (e) => {
//     e.preventDefault();
//     if (!token || !currentUser) return;

//     if (eventFormData.emails && eventFormData.emails.length > 0) {
//       const invalidEmails = eventFormData.emails.filter(email => email.trim() !== "" && !validateEmail(email));
//       if (invalidEmails.length > 0) {
//         toast.error("Please fix all email validation errors");
//         return;
//       }
//     }

//     const data = {
//       ...eventFormData,
//       createdById: currentUser?.id,
//       createdByName: currentUser?.name,
//       companyId: currentUser?.accountType === "COMPANY" ? currentUser?.id : currentUser?.companyId,
//       emails: eventFormData.emails?.filter((email) => email.trim() !== "") || [],
//     };

//     try {
//       if (isEditMode) {
//         await axios.put(`${API_URL}/api/events/${eventFormData.eventId}`, data, { headers });
//       } else {
//         await axios.post(`${API_URL}/api/events`, data, { headers });
//       }
//       setShowEventModal(false);
//       setIsEditMode(false);
//       fetchEvents();
//     } catch (err) {
//       toast.error("Failed to save event");
//       console.error(err);
//     }
//   };

//   const confirmDelete = async () => {
//     if (!token || !deleteConfirm.eventId) return;
//     try {
//       await axios.delete(`${API_URL}/api/events/${deleteConfirm.eventId}`, { headers });
//       setDeleteConfirm({ show: false, eventId: null });
//       fetchEvents(); 
//     } catch (err) {
//       toast.error("Failed to delete event");
//       console.error(err);
//     }
//   };

//   const handleEditClick = (event) => {
//     setIsEditMode(true);
//     setEventFormData({
//       ...event,
//       eventId: event.eventId,
//     });
//     setShowEventModal(true);
//   };

//   const filteredEventsCalendar = events.filter((event) => {
//     if (!event.date) return false;
//     return new Date(event.date).toDateString() === selectedDate.toDateString();
//   });

//   const highlightDates = events.filter((e) => e.date).map((e) => new Date(e.date).toDateString());

//   const getCurrentDate = () => {
//     const now = new Date();
//     return now.toISOString().slice(0, 10);
//   };

//   const getCurrentTime = () => {
//     const now = new Date();
//     return now.toTimeString().slice(0, 5);
//   };

//   const sendEmail = async () => {
//     const validationErrors = emails.map(email => {
//       if (email && !validateEmail(email)) {
//         return "Please enter a valid email address";
//       }
//       return "";
//     });
    
//     setEmailErrors(validationErrors);

//     const hasErrors = validationErrors.some(error => error !== "");
//     if (hasErrors) {
//       toast.error("Please fix all email validation errors");
//       return;
//     }

//     if (!token || !selectedEventIdForEmail) return;

//     try {
//       const validEmails = emails.filter(email => email.trim() !== "");
//       await axios.put(
//         `${API_URL}/api/events/${selectedEventIdForEmail}`,
//         { emails: validEmails },
//         { headers }
//       );
      
//       toast.success("Emails updated successfully");
//       setShowEmailModal(false);
//       setSelectedEventIdForEmail(null);
//       setSelectedEventForEmail(null);
//       setEmails([""]);
//       setEmailErrors([]);
//       fetchEvents();
//     } catch (error) {
//       console.error("Error updating emails:", error);
//       toast.error("Failed to update emails.");
//     }
//   };

//   const ToggleSwitch = ({ isOn, handleToggle, label }) => {
//     return (
//       <div className="flex items-center justify-between">
//         <span className="text-sm font-semibold text-[#374151] dark:text-gray-300">
//           {label}
//         </span>
//         <button
//           type="button"
//           className={`${
//             isOn ? "bg-[#673AB7]" : "bg-gray-300 dark:bg-gray-600"
//           } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#E9D5FF]`}
//           onClick={handleToggle}
//         >
//           <span
//             className={`${
//               isOn ? "translate-x-6" : "translate-x-1"
//             } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
//           />
//         </button>
//       </div>
//     );
//   };

//   const validateEmail = (email) => {
//     const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return re.test(String(email).toLowerCase());
//   };

//   const handleEmailChange = (e, index) => {
//     const newEmails = [...emails];
//     newEmails[index] = e.target.value;
//     setEmails(newEmails);

//     const newErrors = [...emailErrors];
//     if (e.target.value && !validateEmail(e.target.value)) {
//       newErrors[index] = "Please enter a valid email address";
//     } else {
//       newErrors[index] = "";
//     }
//     setEmailErrors(newErrors);
//   };

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); 
//         .cfg-heading { font-family: 'Sora', sans-serif; color: #1F2937; } 
//         .cfg-font { font-family: 'Inter', sans-serif; }

//         .react-calendar {
//           width: 100%;
//           background-color: transparent !important;
//           border: none !important;
//           font-family: inherit;
//         }
//         .dark .react-calendar {
//           background-color: transparent !important;
//           color: white;
//         }
//         .react-calendar__navigation {
//           margin-bottom: 1rem;
//         }
//         .react-calendar__tile {
//           padding: 1rem 0.5rem;
//           border-radius: 0.5rem;
//           position: relative;
//         }
//         .react-calendar__tile--active {
//           background: #673AB7 !important;
//           color: white !important;
//           border-radius: 0.5rem !important;
//           font-weight: bold;
//         }
//         .react-calendar__tile:enabled:hover,
//         .react-calendar__tile:enabled:focus {
//           background-color: #F3E8FF;
//           color: #673AB7;
//           border-radius: 0.5rem;
//         }
//         .dark .react-calendar__tile:enabled:hover,
//         .dark .react-calendar__tile:enabled:focus {
//           background-color: #374151;
//           color: white;
//         }
//         .highlighted-date {
//           background-color: #F3E8FF !important;
//           color: #673AB7 !important;
//           border-radius: 0.5rem !important;
//           font-weight: 600;
//         }
//         .dark .highlighted-date {
//           background-color: rgba(103, 58, 183, 0.3) !important;
//           color: #E9D5FF !important;
//         }
//         .highlighted-date:hover {
//           background-color: #E9D5FF !important;
//         }

//         /* Status highlight classes */
//         .highlighted-status-present {
//           background-color: #dcfce7 !important;
//           color: #166534 !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
//         .highlighted-status-absent {
//           background-color: #fee2e2 !important;
//           color: #991b1b !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
//         .highlighted-status-half_day {
//           background-color: #fef3c7 !important;
//           color: #92400e !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
        
//         /* Leave highlight classes */
//         .highlighted-leave-casual {
//           background-color: #dbeafe !important;
//           color: #1e40af !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
//         .highlighted-leave-sick {
//           background-color: #fee2e2 !important;
//           color: #991b1b !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
//         .highlighted-leave-earned {
//           background-color: #dcfce7 !important;
//           color: #166534 !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
//         .highlighted-leave-maternity {
//           background-color: #ede9fe !important;
//           color: #5b21b6 !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
//         .highlighted-leave-paternity {
//           background-color: #fce7f3 !important;
//           color: #9d174d !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
//         .highlighted-leave-other {
//           background-color: #fef3c7 !important;
//           color: #92400e !important;
//           border-radius: 9999px !important;
//           font-weight: 600;
//         }
        
//         /* Dark mode styles */
//         .dark .highlighted-status-present {
//           background-color: #166534 !important;
//           color: #dcfce7 !important;
//         }
//         .dark .highlighted-status-absent {
//           background-color: #991b1b !important;
//           color: #fee2e2 !important;
//         }
//         .dark .highlighted-status-half_day {
//           background-color: #92400e !important;
//           color: #fef3c7 !important;
//         }
        
//         .dark .highlighted-leave-casual {
//           background-color: #1e40af !important;
//           color: #dbeafe !important;
//         }
//         .dark .highlighted-leave-sick {
//           background-color: #991b1b !important;
//           color: #fee2e2 !important;
//         }
//         .dark .highlighted-leave-earned {
//           background-color: #166534 !important;
//           color: #dcfce7 !important;
//         }
//         .dark .highlighted-leave-maternity {
//           background-color: #5b21b6 !important;
//           color: #ede9fe !important;
//         }
//         .dark .highlighted-leave-paternity {
//           background-color: #9d174d !important;
//           color: #fce7f3 !important;
//         }
//         .dark .highlighted-leave-other {
//           background-color: #92400e !important;
//           color: #fef3c7 !important;
//         }
//       `}</style>
      
//       <div className="w-full min-h-screen bg-[#FAF8FF] dark:bg-gray-900 p-4 md:p-6 lg:p-8 cfg-font shadow-lg rounded-lg relative">
//         <div className="max-w-7xl mx-auto space-y-6">
//           {/* Header Section */}
//           <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-2">
//             <h1 className="text-2xl sm:text-3xl font-bold cfg-heading dark:text-white flex items-center gap-2">
//               📅 Attendance & Leave Calendar
//             </h1>
//             {selectedUserId === currentUser?.id && (
//               <div className="flex gap-2">
//                 <button
//                   onClick={() => setShowLeaveModal(true)}
//                   className="flex items-center gap-2 bg-[#673AB7] hover:bg-[#5E35A6] text-white px-5 py-2.5 rounded-md shadow-sm transition font-semibold text-sm"
//                 >
//                   <FaPlus className="w-4 h-4" /> Apply Leave
//                 </button>
                
//                 {todayAttendance?.checkInTime && !todayAttendance?.checkOutTime ? (
//                   <button
//                     onClick={handleCheckOut}
//                     disabled={isLoading}
//                     className="flex items-center gap-2 bg-[#EF4444] hover:bg-[#B91C1C] text-white px-5 py-2.5 rounded-md shadow-sm transition disabled:opacity-50 font-semibold text-sm"
//                   >
//                     {isLoading ? "Processing..." : "Check Out"}
//                   </button>
//                 ) : (
//                   <button
//                     onClick={handleCheckIn}
//                     disabled={isLoading || (todayAttendance?.checkInTime && todayAttendance?.checkOutTime)}
//                     className="flex items-center gap-2 bg-[#10B981] hover:bg-[#059669] text-white px-5 py-2.5 rounded-md shadow-sm transition disabled:opacity-50 font-semibold text-sm"
//                   >
//                     {isLoading ? "Processing..." : 
//                       (todayAttendance?.checkInTime && todayAttendance?.checkOutTime) ? 
//                       "Already Checked Out" : "Check In"}
//                   </button>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* Select User Dropdown */}
//           {currentUser?.accountType !== "EXECUTIVE" && (
//             <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] p-4 sm:p-6 mb-6 dark:bg-gray-800 dark:border-gray-700">
//               <div className="mb-4">
//                 <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-2">
//                   Select User
//                 </label>
//                 <select
//                   value={selectedUserId || ""}
//                   onChange={handleUserChange}
//                   className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition"
//                 >
//                   <option value="">Select User</option>
//                   {users.map((user) => (
//                     <option key={user.id} value={user.id}>
//                       {user.fname} {user.lname}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               {selectedUserId && (
//                 <div className="text-lg font-bold cfg-heading dark:text-white mt-2">
//                   Viewing records for: <span className="text-[#673AB7] dark:text-[#E9D5FF]">{getSelectedUserName()}</span>
//                 </div>
//               )}
//             </div>
//           )}

//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//             {/* Calendar Section */}
//             <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] p-5 sm:p-6 dark:bg-gray-800 dark:border-gray-700">
//               <div className="flex justify-between items-center mb-4">
//                 <h2 className="text-lg sm:text-xl font-bold cfg-heading text-center dark:text-white">
//                   Pick a Date
//                 </h2>
//                 <button
//                   onClick={() => {
//                     setShowEventModal(true);
//                     setEventFormData({
//                       title: "",
//                       description: "",
//                       date: getCurrentDate(),
//                       time: getCurrentTime(),
//                       ignoreYear: false,
//                       public: false,
//                       createdById: currentUser?.id,
//                       createdByName: currentUser?.name,
//                       companyId: currentUser?.accountType === "COMPANY" ? currentUser?.id : currentUser?.companyId,
//                     });
//                   }}
//                   className="flex items-center gap-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-[#673AB7] px-3 py-1.5 rounded-md transition font-semibold text-sm dark:bg-purple-900/30 dark:text-purple-300"
//                 >
//                   <FaPlus /> Event
//                 </button>
//               </div>

//               <div className="flex justify-center">
//                 <Calendar
//                   onChange={setSelectedDate}
//                   value={selectedDate}
//                   onActiveStartDateChange={({ activeStartDate: newStart }) =>
//                     setActiveStartDate(newStart)
//                   }
//                   className="calendar-custom dark:text-white"
//                   tileClassName={({ date, view }) => {
//                     if (view !== "month") return "";
                    
//                     const dateStr = date.toDateString();
//                     const leaveOnDate = leaveDates.find(d => d.date === dateStr);
//                     const attendanceOnDate = attendanceDates.find(d => d.date === dateStr);
                    
//                     if (leaveOnDate) {
//                       return `highlighted-leave-${leaveOnDate.type.toLowerCase()}`;
//                     }
                    
//                     if (attendanceOnDate) {
//                       return `highlighted-status-${attendanceOnDate.status.toLowerCase()}`;
//                     }
                    
//                     if (highlightDates.includes(dateStr) || calendarHighlightDates.includes(dateStr)) {
//                       return "highlighted-date";
//                     }

//                     return "";
//                   }}
//                   tileContent={tileContent}
//                 />
//               </div>
              
//               {/* Status and Leave Legend */}
//               <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4 border-t border-[#E5E7EB] dark:border-gray-700">
//                 <div>
//                   <h3 className="text-sm font-bold text-[#1F2937] mb-3 cfg-heading dark:text-white">Status Legend</h3>
//                   <div className="grid grid-cols-2 gap-2">
//                     {Object.entries(statusColors).map(([status, { color }]) => (
//                       <div key={status} className="flex items-center">
//                         <div 
//                           className="w-3 h-3 rounded-full mr-2 shadow-sm" 
//                           style={{ backgroundColor: color }}
//                         ></div>
//                         <span className="text-xs font-medium text-[#4B5563] dark:text-gray-300">{status}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//                 <div>
//                   <h3 className="text-sm font-bold text-[#1F2937] mb-3 cfg-heading dark:text-white">Leave Legend</h3>
//                   <div className="grid grid-cols-2 gap-2">
//                     {Object.entries(leaveTypes).map(([type, { color }]) => (
//                       <div key={type} className="flex items-center">
//                         <div 
//                           className="w-3 h-3 rounded-full mr-2 shadow-sm" 
//                           style={{ backgroundColor: color }}
//                         ></div>
//                         <span className="text-xs font-medium text-[#4B5563] dark:text-gray-300">{type}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Records Section */}
//             <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] p-5 sm:p-6 dark:bg-gray-800 dark:border-gray-700 flex flex-col h-full">
//               <h2 className="text-lg sm:text-xl font-bold cfg-heading mb-6 dark:text-white border-b border-[#E5E7EB] dark:border-gray-700 pb-3">
//                 Records on{" "}
//                 <span className="text-[#673AB7] dark:text-[#E9D5FF]">
//                   {selectedDate.toDateString()}
//                 </span>
//               </h2>

//               <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600 pr-2 space-y-6">
//                 {/* Attendance Records */}
//                 <div>
//                   <h3 className="text-base font-bold text-[#1F2937] mb-3 dark:text-white">Attendance</h3>
//                   {filteredAttendance.length > 0 ? (
//                     <ul className="space-y-3">
//                       {filteredAttendance.map((item, index) => (
//                         <li
//                           key={item.id || index}
//                           className="p-4 bg-[#FAF8FF] rounded-lg shadow-sm border border-[#E5E7EB] flex flex-col gap-2 dark:bg-gray-700 dark:border-gray-600"
//                         >
//                           <div className="flex justify-between items-start">
//                             <div>
//                               <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">Status</h3>
//                               <p 
//                                 className="text-base font-bold capitalize mt-0.5"
//                                 style={{ color: statusColors[item.status]?.color }}
//                               >
//                                 {item.status.toLowerCase()}
//                               </p>
//                             </div>
//                             {item.status === 'PRESENT' && (
//                               <div className="flex gap-6">
//                                 <div>
//                                   <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">Check In</h3>
//                                   <p className="text-sm font-bold text-[#374151] dark:text-gray-200 mt-0.5">
//                                     {formatTime(item.checkInTime)}
//                                   </p>
//                                 </div>
//                                 <div>
//                                   <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">Check Out</h3>
//                                   <p className="text-sm font-bold text-[#374151] dark:text-gray-200 mt-0.5">
//                                     {item.checkOutTime ? formatTime(item.checkOutTime) : "Not checked out"}
//                                   </p>
//                                 </div>
//                               </div>
//                             )}
//                           </div>
//                           {item.status === 'PRESENT' && (
//                             <div className="mt-2 pt-2 border-t border-[#E5E7EB] dark:border-gray-600">
//                               <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">Duration</h3>
//                               <p className="text-sm font-bold text-[#374151] dark:text-gray-200 mt-0.5">
//                                 {formatDuration(item.checkInTime, item.checkOutTime)}
//                               </p>
//                             </div>
//                           )}
//                         </li>
//                       ))}
//                     </ul>
//                   ) : (
//                     <div className="p-4 bg-gray-50 border border-dashed border-[#E5E7EB] rounded-lg text-center dark:bg-gray-700 dark:border-gray-600">
//                       <p className="text-[#6B7280] italic text-sm dark:text-gray-400">No attendance records for this date.</p>
//                     </div>
//                   )}
//                 </div>

//                 {/* Leave Records */}
//                 <div>
//                   <h3 className="text-base font-bold text-[#1F2937] mb-3 dark:text-white">Leave</h3>
//                   {filteredLeaves.length > 0 ? (
//                     <ul className="space-y-3">
//                       {filteredLeaves.map((leave, index) => (
//                         <li
//                           key={leave.id || index}
//                           className="p-4 bg-white rounded-lg shadow-sm border border-gray-200 dark:bg-gray-700 dark:border-gray-600"
//                           style={{
//                             borderLeft: `4px solid ${leaveTypes[leave.leaveType]?.color || '#999'}`
//                           }}
//                         >
//                           <div className="grid grid-cols-2 gap-4">
//                             <div>
//                               <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">From</h3>
//                               <p className="text-sm font-bold text-[#374151] dark:text-gray-200 mt-0.5">
//                                 {new Date(leave.fromDate).toLocaleDateString()}
//                               </p>
//                             </div>
//                             <div>
//                               <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">To</h3>
//                               <p className="text-sm font-bold text-[#374151] dark:text-gray-200 mt-0.5">
//                                 {new Date(leave.toDate).toLocaleDateString()}
//                               </p>
//                             </div>
//                           </div>
//                           <div className="mt-3">
//                             <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">Type</h3>
//                             <p className="text-sm font-bold capitalize mt-0.5" style={{ color: leaveTypes[leave.leaveType]?.color }}>
//                               {leave.leaveType.toLowerCase()}
//                             </p>
//                           </div>
//                           {leave.reason && (
//                             <div className="mt-3 pt-3 border-t border-[#E5E7EB] dark:border-gray-600">
//                               <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">Reason</h3>
//                               <p className="text-sm text-[#374151] dark:text-gray-300 mt-0.5">{leave.reason}</p>
//                             </div>
//                           )}
//                         </li>
//                       ))}
//                     </ul>
//                   ) : (
//                     <div className="p-4 bg-gray-50 border border-dashed border-[#E5E7EB] rounded-lg text-center dark:bg-gray-700 dark:border-gray-600">
//                       <p className="text-[#6B7280] italic text-sm dark:text-gray-400">No leave records for this date.</p>
//                     </div>
//                   )}
//                 </div>

//                 {/* Calendar Events (Unified) */}
//                 <div>
//                   <h3 className="text-base font-bold text-[#1F2937] mb-3 dark:text-white">Calendar Events</h3>
//                   {calendarLoading ? (
//                     <p className="text-[#6B7280] italic text-sm text-center py-2 dark:text-gray-400">Loading events...</p>
//                   ) : activitiesForSelectedDate.length > 0 ? (
//                     <ul className="space-y-3">
//                       {activitiesForSelectedDate.map((item) => (
//                         <li
//                           key={`${item.type}-${item.id}`}
//                           className="p-3 bg-[#FAF8FF] rounded-lg shadow-sm border border-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 flex flex-col sm:flex-row items-start justify-between gap-3 transition hover:shadow-md"
//                         >
//                           <div className="flex-1">
//                             <span
//                               className={`inline-block text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded border mb-1.5 ${
//                                 item.type === "MEETING"
//                                   ? "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300"
//                                   : item.type === "TASK"
//                                   ? "bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-900/30 dark:text-purple-300"
//                                   : item.type === "REMINDER"
//                                   ? "bg-yellow-50 text-yellow-700 border-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-300"
//                                   : item.type === "TODO"
//                                   ? "bg-green-50 text-green-700 border-green-200 dark:bg-green-900/30 dark:text-green-300"
//                                   : "bg-[#F3E8FF] text-[#673AB7] border-[#E9D5FF] dark:bg-purple-900/30 dark:text-purple-300"
//                               }`}
//                             >
//                               {item.type}
//                             </span>
//                             <p className="font-bold text-sm text-[#1F2937] dark:text-white">
//                               {item.title}
//                             </p>
//                             {item.description && (
//                               <p className="text-xs text-[#4B5563] mt-1 dark:text-gray-300">
//                                 {item.description}
//                               </p>
//                             )}
//                             {item.time && (
//                               <p className="text-[11px] font-medium text-[#6B7280] mt-1.5 dark:text-gray-400">
//                                 <span className="mr-1">⏰</span> {item.time.slice(0, 5)}
//                               </p>
//                             )}
//                             {item.assignedTo && item.assignedTo.length > 0 && (
//                               <p className="text-[11px] text-[#6B7280] font-medium mt-1 dark:text-gray-400">
//                                 👤 Assigned: {item.assignedTo.map((p) => p.name).join(", ")}
//                               </p>
//                             )}
//                           </div>
                          
//                           <div className="flex flex-row sm:flex-col gap-2 items-center justify-center bg-white dark:bg-gray-800 p-1.5 rounded-md border border-[#E5E7EB] dark:border-gray-600 shadow-sm mt-2 sm:mt-0 w-full sm:w-auto">
//                             {item.type === "EVENT" && (
//                               <>
//                                 <button
//                                   onClick={() => handleEditClick(item)}
//                                   className="text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] transition p-1.5"
//                                   title="Edit"
//                                 >
//                                   <FaEdit className="w-3.5 h-3.5" />
//                                 </button>
//                                 <button
//                                   onClick={() => {
//                                     setSelectedEventIdForEmail(item.id);
//                                     setSelectedEventForEmail(item);
//                                     setEmails(item.emails?.length > 0 ? [...item.emails] : [""]);
//                                     setShowEmailModal(true);
//                                   }}
//                                   className="text-[#10B981] hover:text-[#059669] transition p-1.5"
//                                   title="Manage Emails"
//                                 >
//                                   <FaEnvelope className="w-3.5 h-3.5" />
//                                 </button>
//                                 <button
//                                   onClick={() =>
//                                     setDeleteConfirm({
//                                       show: true,
//                                       eventId: item.id,
//                                     })
//                                   }
//                                   className="text-[#EF4444] hover:text-[#B91C1C] transition p-1.5"
//                                   title="Delete"
//                                 >
//                                   <FaTrash className="w-3.5 h-3.5" />
//                                 </button>
//                               </>
//                             )}
//                             {item.priority && (
//                               <span className="text-[10px] font-semibold text-[#6B7280] dark:text-gray-400 border border-[#E5E7EB] dark:border-gray-600 px-2 py-0.5 rounded">
//                                 {item.priority}
//                               </span>
//                             )}
//                           </div>
//                         </li>
//                       ))}
//                     </ul>
//                   ) : (
//                     <div className="p-4 bg-gray-50 border border-dashed border-[#E5E7EB] rounded-lg text-center dark:bg-gray-700 dark:border-gray-600">
//                       <p className="text-[#6B7280] italic text-sm dark:text-gray-400">No events scheduled for this date.</p>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Add / Edit Event Modal */}
//         {showEventModal && (
//           <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
//             <div className="bg-white w-full max-w-lg mx-auto rounded-xl shadow-2xl relative dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700 flex flex-col max-h-[90vh]">
//               <div className="flex justify-between items-center p-5 border-b border-[#E5E7EB] dark:border-gray-700 bg-[#FAF8FF] dark:bg-gray-800 rounded-t-xl">
//                 <h2 className="text-lg sm:text-xl font-bold cfg-heading text-[#1F2937] dark:text-white">
//                   {isEditMode ? "Edit Event" : "Create a New Event"}
//                 </h2>
//                 <button
//                   onClick={() => setShowEventModal(false)}
//                   className="text-[#6B7280] hover:text-[#EF4444] dark:hover:text-red-400 transition"
//                 >
//                   <FaTimes className="w-5 h-5" />
//                 </button>
//               </div>

//               <div className="p-5 overflow-y-auto scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600">
//                 <form onSubmit={handleEventSubmit} className="space-y-4">
//                   <div>
//                     <label className="block text-sm font-semibold mb-1.5 text-[#374151] dark:text-gray-200">
//                       Title <span className="text-[#EF4444]">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       required
//                       value={eventFormData.title}
//                       onChange={(e) =>
//                         setEventFormData({ ...eventFormData, title: e.target.value })
//                       }
//                       className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                       placeholder="Event title"
//                     />
//                   </div>

//                   <div>
//                     <label className="block text-sm font-semibold mb-1.5 text-[#374151] dark:text-gray-200">
//                       Description
//                     </label>
//                     <textarea
//                       value={eventFormData.description}
//                       onChange={(e) =>
//                         setEventFormData({ ...eventFormData, description: e.target.value })
//                       }
//                       className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] min-h-[100px] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                       placeholder="Event description"
//                     ></textarea>
//                   </div>
                  
//                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                     <div>
//                       <label className="block text-sm font-semibold mb-1.5 text-[#374151] dark:text-gray-200">
//                         Date <span className="text-[#EF4444]">*</span>
//                       </label>
//                       <input
//                         type="date"
//                         required
//                         value={eventFormData.date}
//                         onChange={(e) =>
//                           setEventFormData({ ...eventFormData, date: e.target.value })
//                         }
//                         className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                       />
//                     </div>
//                     <div>
//                       <label className="block text-sm font-semibold mb-1.5 text-[#374151] dark:text-gray-200">
//                         Time <span className="text-[#EF4444]">*</span>
//                       </label>
//                       <input
//                         type="time"
//                         required
//                         value={eventFormData.time}
//                         onChange={(e) =>
//                           setEventFormData({ ...eventFormData, time: e.target.value })
//                         }
//                         className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                       />
//                     </div>
//                   </div>
                  
//                   <div className="space-y-3 mt-2">
//                     {new Date(eventFormData.date) < new Date() && (
//                       <div className="p-3 bg-[#FAF8FF] border border-[#E5E7EB] rounded-md dark:bg-gray-700 dark:border-gray-600">
//                         <ToggleSwitch
//                           isOn={eventFormData.ignoreYear}
//                           handleToggle={() =>
//                             setEventFormData({
//                               ...eventFormData,
//                               ignoreYear: !eventFormData.ignoreYear,
//                             })
//                           }
//                           label="Is this a recurring annual event?"
//                         />
//                       </div>
//                     )}
                    
//                     <div className="p-3 bg-[#FAF8FF] border border-[#E5E7EB] rounded-md dark:bg-gray-700 dark:border-gray-600">
//                       <ToggleSwitch
//                         isOn={eventFormData.public}
//                         handleToggle={() =>
//                           setEventFormData({
//                             ...eventFormData,
//                             public: !eventFormData.public,
//                           })
//                         }
//                         label="Make this event public?"
//                       />
//                     </div>
//                   </div>

//                   <div className="flex justify-end gap-3 border-t border-[#E5E7EB] dark:border-gray-700 pt-4 mt-4">
//                     <button
//                       type="button"
//                       onClick={() => setShowEventModal(false)}
//                       className="px-4 py-2 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       type="submit"
//                       className="px-5 py-2 bg-[#673AB7] text-white rounded-md hover:bg-[#5E35A6] shadow-md transition font-semibold text-sm"
//                     >
//                       Save Event
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Leave Application Modal */}
//         {showLeaveModal && (
//           <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
//             <div className="bg-white rounded-xl shadow-2xl w-full max-w-md dark:bg-gray-800 border border-[#E5E7EB] dark:border-gray-700 overflow-hidden flex flex-col">
//               <div className="flex justify-between items-center p-5 border-b border-[#E5E7EB] dark:border-gray-700 bg-[#FAF8FF] dark:bg-gray-800">
//                 <h2 className="text-lg sm:text-xl font-bold cfg-heading text-[#1F2937] dark:text-white">Apply for Leave</h2>
//                 <button 
//                   onClick={() => setShowLeaveModal(false)}
//                   className="text-[#6B7280] hover:text-[#EF4444] transition-colors"
//                 >
//                   <FaTimes className="w-5 h-5" />
//                 </button>
//               </div>
              
//               <div className="p-5">
//                 <form onSubmit={handleLeaveSubmit} className="space-y-4">
//                   <div>
//                     <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
//                       Leave Type
//                     </label>
//                     <select
//                       name="leaveType"
//                       value={leaveForm.leaveType}
//                       onChange={handleLeaveFormChange}
//                       className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                       required
//                     >
//                       {Object.keys(leaveTypes).map(type => (
//                         <option key={type} value={type}>{type}</option>
//                       ))}
//                     </select>
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
//                       From Date
//                     </label>
//                     <input
//                       type="date"
//                       name="fromDate"
//                       value={leaveForm.fromDate}
//                       onChange={handleLeaveFormChange}
//                       className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                       required
//                       min={new Date().toISOString().split('T')[0]}
//                     />
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
//                       To Date
//                     </label>
//                     <input
//                       type="date"
//                       name="toDate"
//                       value={leaveForm.toDate}
//                       onChange={handleLeaveFormChange}
//                       className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                       required
//                       min={leaveForm.fromDate}
//                     />
//                   </div>
                  
//                   <div>
//                     <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
//                       Reason
//                     </label>
//                     <textarea
//                       name="reason"
//                       value={leaveForm.reason}
//                       onChange={handleLeaveFormChange}
//                       rows={3}
//                       className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white min-h-[80px]"
//                       required
//                     />
//                   </div>
                  
//                   <div className="pt-4 border-t border-[#E5E7EB] dark:border-gray-700 flex justify-end gap-3">
//                     <button
//                       type="button"
//                       onClick={() => setShowLeaveModal(false)}
//                       className="px-4 py-2 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
//                     >
//                       Cancel
//                     </button>
//                     <button
//                       type="submit"
//                       disabled={isLoading}
//                       className="px-5 py-2 bg-[#673AB7] text-white rounded-md hover:bg-[#5E35A6] shadow-md transition font-semibold text-sm disabled:opacity-50"
//                     >
//                       {isLoading ? "Submitting..." : "Submit Leave"}
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Delete Confirmation Modal */}
//         {deleteConfirm.show && (
//           <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/50 p-4">
//             <div className="bg-white w-full max-w-sm rounded-xl shadow-2xl p-6 relative dark:bg-gray-800 border border-[#E5E7EB] dark:border-gray-700 flex flex-col items-center">
//               <div className="w-12 h-12 rounded-full bg-[#FEF2F2] dark:bg-red-900/30 flex items-center justify-center mb-4">
//                 <FaTrash className="text-[#EF4444] text-xl" />
//               </div>
//               <h2 className="text-xl font-bold cfg-heading text-[#1F2937] dark:text-white mb-2">
//                 Delete Confirmation
//               </h2>
//               <p className="text-[#6B7280] dark:text-gray-400 text-center mb-6 text-sm">
//                 Are you sure you want to delete this event? This action cannot be undone.
//               </p>
//               <div className="flex justify-center gap-3 w-full">
//                 <button
//                   onClick={() => setDeleteConfirm({ show: false, eventId: null })}
//                   className="flex-1 px-4 py-2 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={confirmDelete}
//                   className="flex-1 px-4 py-2 bg-[#EF4444] text-white rounded-md hover:bg-[#B91C1C] shadow-md transition font-semibold text-sm"
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Manage Emails Modal */}
//         {showEmailModal && (
//           <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/50 p-4">
//             <div className="bg-white w-full max-w-md rounded-xl shadow-2xl relative dark:bg-gray-800 border border-[#E5E7EB] dark:border-gray-700 flex flex-col max-h-[90vh]">
//               <div className="flex justify-between items-center p-5 border-b border-[#E5E7EB] dark:border-gray-700 bg-[#FAF8FF] dark:bg-gray-800 rounded-t-xl">
//                 <h2 className="text-lg sm:text-xl font-bold cfg-heading text-[#1F2937] dark:text-white truncate pr-4">
//                   {selectedEventForEmail?.title ? `Emails for: ${selectedEventForEmail.title}` : 'Manage Emails'}
//                 </h2>
//                 <button
//                   onClick={() => {
//                     setShowEmailModal(false);
//                     setSelectedEventIdForEmail(null);
//                     setSelectedEventForEmail(null);
//                     setEmails([""]);
//                     setEmailErrors([]);
//                   }}
//                   className="text-[#6B7280] hover:text-[#EF4444] dark:text-gray-300 transition-colors"
//                 >
//                   <FaTimes className="w-5 h-5" />
//                 </button>
//               </div>
              
//               <div className="p-5 overflow-y-auto scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600">
//                 <div className="space-y-3 mb-5">
//                   {emails.map((email, index) => (
//                     <div key={index} className="space-y-1.5">
//                       <div className="flex items-center gap-2">
//                         <input
//                           type="email"
//                           value={email}
//                           onChange={(e) => handleEmailChange(e, index)}
//                           className={`flex-1 p-2.5 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
//                             emailErrors[index] ? "border-[#EF4444]" : "border-[#E5E7EB]"
//                           }`}
//                           placeholder="Enter email"
//                         />
//                         {emails.length > 1 && (
//                           <button
//                             type="button"
//                             onClick={() => {
//                               const newEmails = [...emails];
//                               newEmails.splice(index, 1);
//                               setEmails(newEmails);
                              
//                               const newErrors = [...emailErrors];
//                               newErrors.splice(index, 1);
//                               setEmailErrors(newErrors);
//                             }}
//                             className="text-[#EF4444] hover:text-[#B91C1C] p-2.5 bg-[#FEF2F2] hover:bg-red-100 rounded-md dark:bg-red-900/30 dark:hover:bg-red-900/50 transition"
//                             title="Remove email"
//                           >
//                             <FaTrash />
//                           </button>
//                         )}
//                       </div>
//                       {emailErrors[index] && (
//                         <p className="text-[#EF4444] text-xs font-medium">{emailErrors[index]}</p>
//                       )}
//                     </div>
//                   ))}
//                 </div>

//                 <div className="mb-6">
//                   <button
//                     type="button"
//                     onClick={() => {
//                       setEmails([...emails, ""]);
//                       setEmailErrors([...emailErrors, ""]);
//                     }}
//                     className="flex items-center gap-1.5 px-3 py-1.5 bg-[#F3E8FF] text-[#673AB7] font-semibold text-sm rounded-md hover:bg-[#E9D5FF] dark:bg-purple-900/30 dark:text-purple-300 dark:hover:bg-purple-900/50 transition"
//                   >
//                     <FaPlusCircle /> Add Email
//                   </button>
//                 </div>

//                 <div className="flex justify-end gap-3 border-t border-[#E5E7EB] dark:border-gray-700 pt-4">
//                   <button
//                     type="button"
//                     onClick={() => {
//                       setShowEmailModal(false);
//                       setSelectedEventIdForEmail(null);
//                       setSelectedEventForEmail(null);
//                       setEmails([""]);
//                       setEmailErrors([]);
//                     }}
//                     className="px-4 py-2 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     onClick={sendEmail}
//                     className="px-5 py-2 bg-[#10B981] text-white rounded-md hover:bg-[#059669] shadow-md transition font-semibold text-sm"
//                   >
//                     Save Emails
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// }




import React, { useContext, useEffect, useState } from "react";
import { FaEnvelope, FaPlusCircle, FaTrash, FaPlus, FaTimes, FaEdit } from "react-icons/fa";
import axios from "axios";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";
import { toast } from "react-toastify";

export default function EventCalendar() {
  const { user: currentUser } = useContext(AuthContext);
  const [attendanceData, setAttendanceData] = useState([]);
  const [leaveData, setLeaveData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [todayAttendance, setTodayAttendance] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [leaveForm, setLeaveForm] = useState({
    userId: currentUser?.id,
    leaveType: "CASUAL",
    fromDate: new Date().toISOString().split('T')[0],
    toDate: new Date().toISOString().split('T')[0],
    reason: ""
  });

  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  // Leave types with colors for calendar display
  const leaveTypes = {
    CASUAL: { color: "#3b82f6", textColor: "#ffffff" }, // blue
    SICK: { color: "#DC7633", textColor: "#ffffff" }, // orange/red
    EARNED: { color: "#5D6D7E", textColor: "#ffffff" }, // grey
    MATERNITY: { color: "#8b5cf6", textColor: "#ffffff" }, // purple
    PATERNITY: { color: "#ec4899", textColor: "#ffffff" }, // pink
    OTHER: { color: "#F1C40F", textColor: "#ffffff" } // yellow
  };

  // Status colors
  const statusColors = {
    PRESENT: { color: "#10b981", textColor: "#ffffff" }, // green
    ABSENT: { color: "#ef4444", textColor: "#ffffff" }, // red
    HALF_DAY: { color: "#f59e0b", textColor: "#ffffff" } // yellow
  };

  // Fetch users based on account type
  useEffect(() => {
    async function fetchUsers() {
      if (!currentUser?.id || !currentUser?.accountType) return;

      const url =
        currentUser.accountType === "COMPANY"
          ? `${API_URL}/api/companyuser/getByUserId?userId=${currentUser.id}&accountType=${currentUser.accountType}`
          : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${currentUser.id}&accountType=${currentUser.accountType}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setUsers(data);
        
        // Set the current user as default selected
        if (data.length > 0) {
          setSelectedUserId(currentUser.id);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }

    fetchUsers();
  }, [currentUser, token]);

  // Fetch attendance data when selected user changes
  const fetchAttendanceData = async (userId) => {
    if (!token || !userId) return;
    try {
      const res = await axios.get(`${API_URL}/api/attendance/user/${userId}`, {
        headers,
      });
      setAttendanceData(res.data || []);
    } catch (err) {
      console.error("Error fetching attendance data:", err);
    }
  };

  // Fetch leave data when selected user changes
  const fetchLeaveData = async (userId) => {
    if (!token || !userId) return;
    try {
      const res = await axios.get(`${API_URL}/api/leave/user/${userId}`, {
        headers,
      });
      setLeaveData(res.data || []);
    } catch (err) {
      console.error("Error fetching leave data:", err);
    }
  };

  // Check today's attendance for the selected user
  const checkTodayAttendance = async (userId) => {
    if (!token || !userId) return;
    setIsLoading(true);
    try {
      const today = new Date().toISOString().split('T')[0];
      const res = await axios.get(`${API_URL}/api/attendance/user/${userId}`, {
        headers,
      });
      
      // Find today's attendance record
      const todayRecord = res.data.find(item => {
        const itemDate = new Date(item.date).toISOString().split('T')[0];
        return itemDate === today;
      });
      
      setTodayAttendance(todayRecord || null);
    } catch (err) {
      console.error("Error checking today's attendance:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedUserId) {
      fetchAttendanceData(selectedUserId);
      fetchLeaveData(selectedUserId);
      checkTodayAttendance(selectedUserId);
    }
  }, [selectedUserId]);

  const handleCheckIn = async () => {
    if (!token || !selectedUserId) return;
    setIsLoading(true);
    try {
      await axios.post(`${API_URL}/api/attendance/checkin/${selectedUserId}`, {}, { headers });
      toast.success("Checked in successfully");
      await checkTodayAttendance(selectedUserId);
      await fetchAttendanceData(selectedUserId);
    } catch (err) {
      toast.error("Failed to check in");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCheckOut = async () => {
    if (!token || !selectedUserId) return;
    setIsLoading(true);
    try {
      await axios.post(`${API_URL}/api/attendance/checkout/${selectedUserId}`, {}, { headers });
      toast.success("Checked out successfully");
      await checkTodayAttendance(selectedUserId);
      await fetchAttendanceData(selectedUserId);
    } catch (err) {
      toast.error("Failed to check out");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLeaveSubmit = async (e) => {
    e.preventDefault();
    if (!token) return;
    setIsLoading(true);
    try {
      await axios.post(`${API_URL}/api/leave/apply`, leaveForm, { headers });
      toast.success("Leave applied successfully");
      setShowLeaveModal(false);
      await fetchLeaveData(selectedUserId);
      setLeaveForm({
        leaveType: "CASUAL",
        fromDate: new Date().toISOString().split('T')[0],
        toDate: new Date().toISOString().split('T')[0],
        reason: ""
      });
    } catch (err) {
      toast.error("Failed to apply leave");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLeaveFormChange = (e) => {
    const { name, value } = e.target;
    setLeaveForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Get all attendance dates with status for the selected user
  const getAttendanceDates = () => {
    return attendanceData.map(item => ({
      date: new Date(item.date).toDateString(),
      status: item.status
    }));
  };

  const attendanceDates = getAttendanceDates();

  // Get all leave dates for the selected user
  const getLeaveDates = () => {
    const leaveDates = [];
    leaveData.forEach(leave => {
      const fromDate = new Date(leave.fromDate);
      const toDate = new Date(leave.toDate);
      
      // Add all dates in the leave range
      for (let date = new Date(fromDate); date <= toDate; date.setDate(date.getDate() + 1)) {
        leaveDates.push({
          date: new Date(date).toDateString(),
          type: leave.leaveType
        });
      }
    });
    return leaveDates;
  };

  const leaveDates = getLeaveDates();

  const filteredAttendance = attendanceData.filter((item) => {
    return new Date(item.date).toDateString() === selectedDate.toDateString();
  });

  const filteredLeaves = leaveData.filter(leave => {
    const fromDate = new Date(leave.fromDate);
    const toDate = new Date(leave.toDate);
    const selected = new Date(selectedDate);
    return selected >= fromDate && selected <= toDate;
  });

  const formatTime = (dateString) => {
    if (!dateString) return "_";
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const formatDuration = (checkIn, checkOut) => {
    if (!checkIn || !checkOut) return "_";
    
    const start = new Date(checkIn);
    const end = new Date(checkOut);
    const diff = Math.abs(end - start);
    
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    
    return `${hours}h ${minutes}m`;
  };

  const handleUserChange = (e) => {
    const userId = e.target.value;
    setSelectedUserId(userId);
  };

  const getSelectedUserName = () => {
    if (!selectedUserId) return "";
    const selectedUser = users.find(u => u.id === selectedUserId);
    return selectedUser ? `${selectedUser.fname} ${selectedUser.lname}` : "";
  };

  // Custom tile content for calendar to show leave and status indicators
  const tileContent = ({ date, view }) => {
    if (view !== 'month') return null;
    
    const dateStr = date.toDateString();
    const leaveOnDate = leaveDates.find(d => d.date === dateStr);
    const attendanceOnDate = attendanceDates.find(d => d.date === dateStr);
    
    // Create a small indicator for the corner
    const indicatorStyle = {
      position: 'absolute',
      top: '5px',
      right: '5px',
      width: '16px',
      height: '16px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '10px',
      fontWeight: 'bold'
    };

    if (!leaveOnDate && attendanceOnDate) {
      const status = attendanceOnDate.status;
      return (
        <div 
          style={{
            ...indicatorStyle,
            backgroundColor: statusColors[status]?.color,
            color: statusColors[status]?.textColor
          }}
        >
          {status.charAt(0)}
        </div>
      );
    }
    
    if (leaveOnDate) {
      return (
        <div 
          style={{
            ...indicatorStyle,
            backgroundColor: leaveTypes[leaveOnDate.type]?.color,
            color: leaveTypes[leaveOnDate.type]?.textColor
          }}
        >
          {leaveOnDate.type.charAt(0)}
        </div>
      );
    }
    
    return null;
  };

  // Original events fetching for the calendar component
  const [events, setEvents] = useState([]);
  const [deleteConfirm, setDeleteConfirm] = useState({ show: false, eventId: null });
  const [isEditMode, setIsEditMode] = useState(false);
  const [eventFormData, setEventFormData] = useState({
    title: "",
    description: "",
    date: "",
    ignoreYear: false,
    public: false,
    time: "",
    createdById: "",
    createdByName: "",
    companyId: "",
    emails: [],
  });
  const [showEventModal, setShowEventModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emails, setEmails] = useState([""]);
  const [selectedEventIdForEmail, setSelectedEventIdForEmail] = useState(null);
  const [selectedEventForEmail, setSelectedEventForEmail] = useState(null);
  const [emailErrors, setEmailErrors] = useState([]);
  const [activeStartDate, setActiveStartDate] = useState(new Date());
  const [calendarData, setCalendarData] = useState({
    events: [],
    eventsByDate: {},
    totalEvents: 0,
  });
  const [calendarLoading, setCalendarLoading] = useState(false);

  const fetchEvents = async () => {
    if (!token || !currentUser) return;
    try {
      const res =
        currentUser.accountType === "COMPANY"
          ? await axios.get(`${API_URL}/api/events/company/${currentUser.id}`, { headers })
          : await axios.get(`${API_URL}/api/events/company/${currentUser.companyId}/createdBy/${currentUser.id}`, { headers });
      setEvents(res.data.events || []);
    } catch (err) {
      console.error("Error fetching events:", err);
    }
  };

  useEffect(() => {
    if (!currentUser) return;
    setEventFormData((prev) => ({
      ...prev,
      createdById: currentUser?.id,
      createdByName: currentUser?.name,
      companyId: currentUser?.accountType === "COMPANY" ? currentUser?.id : currentUser?.companyId,
    }));
    fetchEvents();
  }, [currentUser]);

  const fetchCalendarMonth = async (date) => {
    if (!token || !currentUser) return;
    try {
      setCalendarLoading(true);
      const companyId = currentUser.accountType === "COMPANY" ? currentUser.id : currentUser.companyId;
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const res = await axios.get(
        `${API_URL}/api/calendar/month/${companyId}?year=${year}&month=${month}&userId=${currentUser.id}`,
        { headers }
      );
      setCalendarData({
        events: res.data?.events || [],
        eventsByDate: res.data?.eventsByDate || {},
        totalEvents: res.data?.totalEvents || 0,
      });
    } catch (err) {
      console.error("Error fetching calendar data:", err);
      setCalendarData({ events: [], eventsByDate: {}, totalEvents: 0 });
    } finally {
      setCalendarLoading(false);
    }
  };

  useEffect(() => {
    if (!currentUser) return;
    fetchCalendarMonth(activeStartDate);
  }, [currentUser, activeStartDate]);

  const selectedDateKey = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, "0")}-${String(selectedDate.getDate()).padStart(2, "0")}`;
  const activitiesForSelectedDate = calendarData.eventsByDate?.[selectedDateKey] || [];
  const calendarHighlightDates = Object.keys(calendarData.eventsByDate || {}).map((d) => new Date(d).toDateString());

  const handleEventSubmit = async (e) => {
    e.preventDefault();
    if (!token || !currentUser) return;

    if (eventFormData.emails && eventFormData.emails.length > 0) {
      const invalidEmails = eventFormData.emails.filter(email => email.trim() !== "" && !validateEmail(email));
      if (invalidEmails.length > 0) {
        toast.error("Please fix all email validation errors");
        return;
      }
    }

    const data = {
      ...eventFormData,
      createdById: currentUser?.id,
      createdByName: currentUser?.name,
      companyId: currentUser?.accountType === "COMPANY" ? currentUser?.id : currentUser?.companyId,
      emails: eventFormData.emails?.filter((email) => email.trim() !== "") || [],
    };

    try {
      if (isEditMode) {
        await axios.put(`${API_URL}/api/events/${eventFormData.eventId}`, data, { headers });
      } else {
        await axios.post(`${API_URL}/api/events`, data, { headers });
      }
      setShowEventModal(false);
      setIsEditMode(false);
      fetchEvents();
    } catch (err) {
      toast.error("Failed to save event");
      console.error(err);
    }
  };

  const confirmDelete = async () => {
    if (!token || !deleteConfirm.eventId) return;
    try {
      await axios.delete(`${API_URL}/api/events/${deleteConfirm.eventId}`, { headers });
      setDeleteConfirm({ show: false, eventId: null });
      fetchEvents(); 
    } catch (err) {
      toast.error("Failed to delete event");
      console.error(err);
    }
  };

  const handleEditClick = (event) => {
    setIsEditMode(true);
    setEventFormData({
      ...event,
      eventId: event.eventId,
    });
    setShowEventModal(true);
  };

  const filteredEventsCalendar = events.filter((event) => {
    if (!event.date) return false;
    return new Date(event.date).toDateString() === selectedDate.toDateString();
  });

  const highlightDates = events.filter((e) => e.date).map((e) => new Date(e.date).toDateString());

  const getCurrentDate = () => {
    const now = new Date();
    return now.toISOString().slice(0, 10);
  };

  const getCurrentTime = () => {
    const now = new Date();
    return now.toTimeString().slice(0, 5);
  };

  const sendEmail = async () => {
    const validationErrors = emails.map(email => {
      if (email && !validateEmail(email)) {
        return "Please enter a valid email address";
      }
      return "";
    });
    
    setEmailErrors(validationErrors);

    const hasErrors = validationErrors.some(error => error !== "");
    if (hasErrors) {
      toast.error("Please fix all email validation errors");
      return;
    }

    if (!token || !selectedEventIdForEmail) return;

    try {
      const validEmails = emails.filter(email => email.trim() !== "");
      await axios.put(
        `${API_URL}/api/events/${selectedEventIdForEmail}`,
        { emails: validEmails },
        { headers }
      );
      
      toast.success("Emails updated successfully");
      setShowEmailModal(false);
      setSelectedEventIdForEmail(null);
      setSelectedEventForEmail(null);
      setEmails([""]);
      setEmailErrors([]);
      fetchEvents();
    } catch (error) {
      console.error("Error updating emails:", error);
      toast.error("Failed to update emails.");
    }
  };

  const ToggleSwitch = ({ isOn, handleToggle, label }) => {
    return (
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-[#374151] dark:text-gray-300">
          {label}
        </span>
        <button
          type="button"
          className={`${
            isOn ? "bg-[#673AB7]" : "bg-gray-300 dark:bg-gray-600"
          } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#E9D5FF]`}
          onClick={handleToggle}
        >
          <span
            className={`${
              isOn ? "translate-x-6" : "translate-x-1"
            } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
          />
        </button>
      </div>
    );
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const handleEmailChange = (e, index) => {
    const newEmails = [...emails];
    newEmails[index] = e.target.value;
    setEmails(newEmails);

    const newErrors = [...emailErrors];
    if (e.target.value && !validateEmail(e.target.value)) {
      newErrors[index] = "Please enter a valid email address";
    } else {
      newErrors[index] = "";
    }
    setEmailErrors(newErrors);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); 
        .cfg-heading { font-family: 'Sora', sans-serif; color: #1F2937; } 
        .cfg-font { font-family: 'Inter', sans-serif; }

        .react-calendar {
          width: 100%;
          background-color: transparent !important;
          border: none !important;
          font-family: inherit;
        }
        .dark .react-calendar {
          background-color: transparent !important;
          color: white;
        }
        .react-calendar__navigation {
          margin-bottom: 1rem;
        }
        .react-calendar__tile {
          padding: 1rem 0.5rem;
          border-radius: 0.5rem;
          position: relative;
        }
        .react-calendar__tile--active {
          background: #673AB7 !important;
          color: white !important;
          border-radius: 0.5rem !important;
          font-weight: bold;
        }
        .react-calendar__tile:enabled:hover,
        .react-calendar__tile:enabled:focus {
          background-color: #F3E8FF;
          color: #673AB7;
          border-radius: 0.5rem;
        }
        .dark .react-calendar__tile:enabled:hover,
        .dark .react-calendar__tile:enabled:focus {
          background-color: #374151;
          color: white;
        }
        .highlighted-date {
          background-color: #F3E8FF !important;
          color: #673AB7 !important;
          border-radius: 0.5rem !important;
          font-weight: 600;
        }
        .dark .highlighted-date {
          background-color: rgba(103, 58, 183, 0.3) !important;
          color: #E9D5FF !important;
        }
        .highlighted-date:hover {
          background-color: #E9D5FF !important;
        }

        /* Status highlight classes */
        .highlighted-status-present {
          background-color: #dcfce7 !important;
          color: #166534 !important;
          border-radius: 9999px !important;
          font-weight: 600;
        }
        .highlighted-status-absent {
          background-color: #fee2e2 !important;
          color: #991b1b !important;
          border-radius: 9999px !important;
          font-weight: 600;
        }
        .highlighted-status-half_day {
          background-color: #fef3c7 !important;
          color: #92400e !important;
          border-radius: 9999px !important;
          font-weight: 600;
        }
        
        /* Leave highlight classes */
        .highlighted-leave-casual {
          background-color: #dbeafe !important;
          color: #1e40af !important;
          border-radius: 9999px !important;
          font-weight: 600;
        }
        .highlighted-leave-sick {
          background-color: #fee2e2 !important;
          color: #991b1b !important;
          border-radius: 9999px !important;
          font-weight: 600;
        }
        .highlighted-leave-earned {
          background-color: #dcfce7 !important;
          color: #166534 !important;
          border-radius: 9999px !important;
          font-weight: 600;
        }
        .highlighted-leave-maternity {
          background-color: #ede9fe !important;
          color: #5b21b6 !important;
          border-radius: 9999px !important;
          font-weight: 600;
        }
        .highlighted-leave-paternity {
          background-color: #fce7f3 !important;
          color: #9d174d !important;
          border-radius: 9999px !important;
          font-weight: 600;
        }
        .highlighted-leave-other {
          background-color: #fef3c7 !important;
          color: #92400e !important;
          border-radius: 9999px !important;
          font-weight: 600;
        }
        
        /* Dark mode styles */
        .dark .highlighted-status-present {
          background-color: #166534 !important;
          color: #dcfce7 !important;
        }
        .dark .highlighted-status-absent {
          background-color: #991b1b !important;
          color: #fee2e2 !important;
        }
        .dark .highlighted-status-half_day {
          background-color: #92400e !important;
          color: #fef3c7 !important;
        }
        
        .dark .highlighted-leave-casual {
          background-color: #1e40af !important;
          color: #dbeafe !important;
        }
        .dark .highlighted-leave-sick {
          background-color: #991b1b !important;
          color: #fee2e2 !important;
        }
        .dark .highlighted-leave-earned {
          background-color: #166534 !important;
          color: #dcfce7 !important;
        }
        .dark .highlighted-leave-maternity {
          background-color: #5b21b6 !important;
          color: #ede9fe !important;
        }
        .dark .highlighted-leave-paternity {
          background-color: #9d174d !important;
          color: #fce7f3 !important;
        }
        .dark .highlighted-leave-other {
          background-color: #92400e !important;
          color: #fef3c7 !important;
        }
      `}</style>
      
      <div className="w-full min-h-screen bg-[#FAF8FF] dark:bg-gray-900 p-4 md:p-6 lg:p-8 cfg-font shadow-lg rounded-lg relative">
        <div className="max-w-7xl mx-auto space-y-6">
          {/* Header Section */}
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-2">
            <h1 className="text-2xl sm:text-3xl font-bold cfg-heading dark:text-white flex items-center gap-2">
              📅 Attendance & Leave Calendar
            </h1>
            {selectedUserId === currentUser?.id && (
              <div className="flex gap-2">
                <button
                  onClick={() => setShowLeaveModal(true)}
                  className="flex items-center gap-2 bg-[#673AB7] hover:bg-[#5E35A6] text-white px-5 py-2.5 rounded-md shadow-sm transition font-semibold text-sm"
                >
                  <FaPlus className="w-4 h-4" /> Apply Leave
                </button>
                
                {todayAttendance?.checkInTime && !todayAttendance?.checkOutTime ? (
                  <button
                    onClick={handleCheckOut}
                    disabled={isLoading}
                    className="flex items-center gap-2 bg-[#EF4444] hover:bg-[#B91C1C] text-white px-5 py-2.5 rounded-md shadow-sm transition disabled:opacity-50 font-semibold text-sm"
                  >
                    {isLoading ? "Processing..." : "Check Out"}
                  </button>
                ) : (
                  <button
                    onClick={handleCheckIn}
                    disabled={isLoading || (todayAttendance?.checkInTime && todayAttendance?.checkOutTime)}
                    className="flex items-center gap-2 bg-[#10B981] hover:bg-[#059669] text-white px-5 py-2.5 rounded-md shadow-sm transition disabled:opacity-50 font-semibold text-sm"
                  >
                    {isLoading ? "Processing..." : 
                      (todayAttendance?.checkInTime && todayAttendance?.checkOutTime) ? 
                      "Already Checked Out" : "Check In"}
                  </button>
                )}
              </div>
            )}
          </div>

          {/* Select User Dropdown */}
          {currentUser?.accountType !== "EXECUTIVE" && (
            <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] p-4 mb-6 dark:bg-gray-800 dark:border-gray-700 w-full max-w-sm">
              <div className="mb-2">
                <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
                  Select User
                </label>
                <select
                  value={selectedUserId || ""}
                  onChange={handleUserChange}
                  className="w-full p-2 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white transition text-sm"
                >
                  <option value="">Select User</option>
                  {users.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.fname} {user.lname}
                    </option>
                  ))}
                </select>
              </div>
              {selectedUserId && (
                <div className="text-sm font-semibold cfg-heading dark:text-white mt-2 border-t border-gray-100 dark:border-gray-700 pt-2">
                  Viewing records for: <span className="text-[#673AB7] dark:text-[#E9D5FF] font-bold">{getSelectedUserName()}</span>
                </div>
              )}
            </div>
          )}

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Calendar Section */}
            <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] p-5 sm:p-6 dark:bg-gray-800 dark:border-gray-700">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg sm:text-xl font-bold cfg-heading text-center dark:text-white">
                  Pick a Date
                </h2>
                <button
                  onClick={() => {
                    setShowEventModal(true);
                    setEventFormData({
                      title: "",
                      description: "",
                      date: getCurrentDate(),
                      time: getCurrentTime(),
                      ignoreYear: false,
                      public: false,
                      createdById: currentUser?.id,
                      createdByName: currentUser?.name,
                      companyId: currentUser?.accountType === "COMPANY" ? currentUser?.id : currentUser?.companyId,
                    });
                  }}
                  className="flex items-center gap-1.5 bg-[#F3E8FF] hover:bg-[#E9D5FF] text-[#673AB7] px-3 py-1.5 rounded-md transition font-semibold text-sm dark:bg-purple-900/30 dark:text-purple-300"
                >
                  <FaPlus /> Event
                </button>
              </div>

              <div className="flex justify-center">
                <Calendar
                  onChange={setSelectedDate}
                  value={selectedDate}
                  onActiveStartDateChange={({ activeStartDate: newStart }) =>
                    setActiveStartDate(newStart)
                  }
                  className="calendar-custom dark:text-white"
                  tileClassName={({ date, view }) => {
                    if (view !== "month") return "";
                    
                    const dateStr = date.toDateString();
                    const leaveOnDate = leaveDates.find(d => d.date === dateStr);
                    const attendanceOnDate = attendanceDates.find(d => d.date === dateStr);
                    
                    if (leaveOnDate) {
                      return `highlighted-leave-${leaveOnDate.type.toLowerCase()}`;
                    }
                    
                    if (attendanceOnDate) {
                      return `highlighted-status-${attendanceOnDate.status.toLowerCase()}`;
                    }
                    
                    if (highlightDates.includes(dateStr) || calendarHighlightDates.includes(dateStr)) {
                      return "highlighted-date";
                    }

                    return "";
                  }}
                  tileContent={tileContent}
                />
              </div>
              
              {/* Status and Leave Legend */}
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4 border-t border-[#E5E7EB] dark:border-gray-700">
                <div>
                  <h3 className="text-sm font-bold text-[#1F2937] mb-3 cfg-heading dark:text-white">Status Legend</h3>
                  <div className="grid grid-cols-2 gap-2">
                    {Object.entries(statusColors).map(([status, { color }]) => (
                      <div key={status} className="flex items-center">
                        <div 
                          className="w-3 h-3 rounded-full mr-2 shadow-sm" 
                          style={{ backgroundColor: color }}
                        ></div>
                        <span className="text-xs font-medium text-[#4B5563] dark:text-gray-300">{status}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div>
                  <h3 className="text-sm font-bold text-[#1F2937] mb-3 cfg-heading dark:text-white">Leave Legend</h3>
                  <div className="grid grid-cols-2 gap-2">
                    {Object.entries(leaveTypes).map(([type, { color }]) => (
                      <div key={type} className="flex items-center">
                        <div 
                          className="w-3 h-3 rounded-full mr-2 shadow-sm" 
                          style={{ backgroundColor: color }}
                        ></div>
                        <span className="text-xs font-medium text-[#4B5563] dark:text-gray-300">{type}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Records Section */}
            <div className="bg-white rounded-xl shadow-sm border border-[#E5E7EB] p-5 sm:p-6 dark:bg-gray-800 dark:border-gray-700 flex flex-col h-full">
              <h2 className="text-lg sm:text-xl font-bold cfg-heading mb-6 dark:text-white border-b border-[#E5E7EB] dark:border-gray-700 pb-3">
                Records on{" "}
                <span className="text-[#673AB7] dark:text-[#E9D5FF]">
                  {selectedDate.toDateString()}
                </span>
              </h2>

              <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600 pr-2 space-y-6">
                {/* Attendance Records */}
                <div>
                  <h3 className="text-base font-bold text-[#1F2937] mb-3 dark:text-white">Attendance</h3>
                  {filteredAttendance.length > 0 ? (
                    <ul className="space-y-3">
                      {filteredAttendance.map((item, index) => (
                        <li
                          key={item.id || index}
                          className="p-4 bg-[#FAF8FF] rounded-lg shadow-sm border border-[#E5E7EB] flex flex-col gap-2 dark:bg-gray-700 dark:border-gray-600"
                        >
                          <div className="flex justify-between items-start">
                            <div>
                              <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">Status</h3>
                              <p 
                                className="text-base font-bold capitalize mt-0.5"
                                style={{ color: statusColors[item.status]?.color }}
                              >
                                {item.status.toLowerCase()}
                              </p>
                            </div>
                            {item.status === 'PRESENT' && (
                              <div className="flex gap-6">
                                <div>
                                  <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">Check In</h3>
                                  <p className="text-sm font-bold text-[#374151] dark:text-gray-200 mt-0.5">
                                    {formatTime(item.checkInTime)}
                                  </p>
                                </div>
                                <div>
                                  <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">Check Out</h3>
                                  <p className="text-sm font-bold text-[#374151] dark:text-gray-200 mt-0.5">
                                    {item.checkOutTime ? formatTime(item.checkOutTime) : "Not checked out"}
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                          {item.status === 'PRESENT' && (
                            <div className="mt-2 pt-2 border-t border-[#E5E7EB] dark:border-gray-600">
                              <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">Duration</h3>
                              <p className="text-sm font-bold text-[#374151] dark:text-gray-200 mt-0.5">
                                {formatDuration(item.checkInTime, item.checkOutTime)}
                              </p>
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="p-4 bg-gray-50 border border-dashed border-[#E5E7EB] rounded-lg text-center dark:bg-gray-700 dark:border-gray-600">
                      <p className="text-[#6B7280] italic text-sm dark:text-gray-400">No attendance records for this date.</p>
                    </div>
                  )}
                </div>

                {/* Leave Records */}
                <div>
                  <h3 className="text-base font-bold text-[#1F2937] mb-3 dark:text-white">Leave</h3>
                  {filteredLeaves.length > 0 ? (
                    <ul className="space-y-3">
                      {filteredLeaves.map((leave, index) => (
                        <li
                          key={leave.id || index}
                          className="p-4 bg-white rounded-lg shadow-sm border border-gray-200 dark:bg-gray-700 dark:border-gray-600"
                          style={{
                            borderLeft: `4px solid ${leaveTypes[leave.leaveType]?.color || '#999'}`
                          }}
                        >
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">From</h3>
                              <p className="text-sm font-bold text-[#374151] dark:text-gray-200 mt-0.5">
                                {new Date(leave.fromDate).toLocaleDateString()}
                              </p>
                            </div>
                            <div>
                              <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">To</h3>
                              <p className="text-sm font-bold text-[#374151] dark:text-gray-200 mt-0.5">
                                {new Date(leave.toDate).toLocaleDateString()}
                              </p>
                            </div>
                          </div>
                          <div className="mt-3">
                            <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">Type</h3>
                            <p className="text-sm font-bold capitalize mt-0.5" style={{ color: leaveTypes[leave.leaveType]?.color }}>
                              {leave.leaveType.toLowerCase()}
                            </p>
                          </div>
                          {leave.reason && (
                            <div className="mt-3 pt-3 border-t border-[#E5E7EB] dark:border-gray-600">
                              <h3 className="text-xs font-semibold text-[#6B7280] uppercase tracking-wider dark:text-gray-400">Reason</h3>
                              <p className="text-sm text-[#374151] dark:text-gray-300 mt-0.5">{leave.reason}</p>
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="p-4 bg-gray-50 border border-dashed border-[#E5E7EB] rounded-lg text-center dark:bg-gray-700 dark:border-gray-600">
                      <p className="text-[#6B7280] italic text-sm dark:text-gray-400">No leave records for this date.</p>
                    </div>
                  )}
                </div>

                {/* Calendar Events (Unified) */}
                <div>
                  <h3 className="text-base font-bold text-[#1F2937] mb-3 dark:text-white">Calendar Events</h3>
                  {calendarLoading ? (
                    <p className="text-[#6B7280] italic text-sm text-center py-2 dark:text-gray-400">Loading events...</p>
                  ) : activitiesForSelectedDate.length > 0 ? (
                    <ul className="space-y-3">
                      {activitiesForSelectedDate.map((item) => (
                        <li
                          key={`${item.type}-${item.id}`}
                          className="p-3 bg-[#FAF8FF] rounded-lg shadow-sm border border-[#E5E7EB] dark:bg-gray-700 dark:border-gray-600 flex flex-col sm:flex-row items-start justify-between gap-3 transition hover:shadow-md"
                        >
                          <div className="flex-1">
                            <span
                              className={`inline-block text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded border mb-1.5 ${
                                item.type === "MEETING"
                                  ? "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300"
                                  : item.type === "TASK"
                                  ? "bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-900/30 dark:text-purple-300"
                                  : item.type === "REMINDER"
                                  ? "bg-yellow-50 text-yellow-700 border-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-300"
                                  : item.type === "TODO"
                                  ? "bg-green-50 text-green-700 border-green-200 dark:bg-green-900/30 dark:text-green-300"
                                  : "bg-[#F3E8FF] text-[#673AB7] border-[#E9D5FF] dark:bg-purple-900/30 dark:text-purple-300"
                              }`}
                            >
                              {item.type}
                            </span>
                            <p className="font-bold text-sm text-[#1F2937] dark:text-white">
                              {item.title}
                            </p>
                            {item.description && (
                              <p className="text-xs text-[#4B5563] mt-1 dark:text-gray-300">
                                {item.description}
                              </p>
                            )}
                            {item.time && (
                              <p className="text-[11px] font-medium text-[#6B7280] mt-1.5 dark:text-gray-400">
                                <span className="mr-1">⏰</span> {item.time.slice(0, 5)}
                              </p>
                            )}
                            {item.assignedTo && item.assignedTo.length > 0 && (
                              <p className="text-[11px] text-[#6B7280] font-medium mt-1 dark:text-gray-400">
                                👤 Assigned: {item.assignedTo.map((p) => p.name).join(", ")}
                              </p>
                            )}
                          </div>
                          
                          <div className="flex flex-row sm:flex-col gap-2 items-center justify-center bg-white dark:bg-gray-800 p-1.5 rounded-md border border-[#E5E7EB] dark:border-gray-600 shadow-sm mt-2 sm:mt-0 w-full sm:w-auto">
                            {item.type === "EVENT" && (
                              <>
                                <button
                                  onClick={() => handleEditClick(item)}
                                  className="text-[#8B5CF6] hover:text-[#673AB7] dark:hover:text-[#E9D5FF] transition p-1.5"
                                  title="Edit"
                                >
                                  <FaEdit className="w-3.5 h-3.5" />
                                </button>
                                <button
                                  onClick={() => {
                                    setSelectedEventIdForEmail(item.id);
                                    setSelectedEventForEmail(item);
                                    setEmails(item.emails?.length > 0 ? [...item.emails] : [""]);
                                    setShowEmailModal(true);
                                  }}
                                  className="text-[#10B981] hover:text-[#059669] transition p-1.5"
                                  title="Manage Emails"
                                >
                                  <FaEnvelope className="w-3.5 h-3.5" />
                                </button>
                                <button
                                  onClick={() =>
                                    setDeleteConfirm({
                                      show: true,
                                      eventId: item.id,
                                    })
                                  }
                                  className="text-[#EF4444] hover:text-[#B91C1C] transition p-1.5"
                                  title="Delete"
                                >
                                  <FaTrash className="w-3.5 h-3.5" />
                                </button>
                              </>
                            )}
                            {item.priority && (
                              <span className="text-[10px] font-semibold text-[#6B7280] dark:text-gray-400 border border-[#E5E7EB] dark:border-gray-600 px-2 py-0.5 rounded">
                                {item.priority}
                              </span>
                            )}
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="p-4 bg-gray-50 border border-dashed border-[#E5E7EB] rounded-lg text-center dark:bg-gray-700 dark:border-gray-600">
                      <p className="text-[#6B7280] italic text-sm dark:text-gray-400">No events scheduled for this date.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add / Edit Event Modal */}
        {showEventModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="bg-white w-full max-w-lg mx-auto rounded-xl shadow-2xl relative dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700 flex flex-col max-h-[90vh]">
              <div className="flex justify-between items-center p-5 border-b border-[#E5E7EB] dark:border-gray-700 bg-[#FAF8FF] dark:bg-gray-800 rounded-t-xl">
                <h2 className="text-lg sm:text-xl font-bold cfg-heading text-[#1F2937] dark:text-white">
                  {isEditMode ? "Edit Event" : "Create a New Event"}
                </h2>
                <button
                  onClick={() => setShowEventModal(false)}
                  className="text-[#6B7280] hover:text-[#EF4444] dark:hover:text-red-400 transition"
                >
                  <FaTimes className="w-5 h-5" />
                </button>
              </div>

              <div className="p-5 overflow-y-auto scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600">
                <form onSubmit={handleEventSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm font-semibold mb-1.5 text-[#374151] dark:text-gray-200">
                      Title <span className="text-[#EF4444]">*</span>
                    </label>
                    <input
                      type="text"
                      required
                      value={eventFormData.title}
                      onChange={(e) =>
                        setEventFormData({ ...eventFormData, title: e.target.value })
                      }
                      className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                      placeholder="Event title"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold mb-1.5 text-[#374151] dark:text-gray-200">
                      Description
                    </label>
                    <textarea
                      value={eventFormData.description}
                      onChange={(e) =>
                        setEventFormData({ ...eventFormData, description: e.target.value })
                      }
                      className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] min-h-[100px] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                      placeholder="Event description"
                    ></textarea>
                  </div>
                  
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-semibold mb-1.5 text-[#374151] dark:text-gray-200">
                        Date <span className="text-[#EF4444]">*</span>
                      </label>
                      <input
                        type="date"
                        required
                        value={eventFormData.date}
                        onChange={(e) =>
                          setEventFormData({ ...eventFormData, date: e.target.value })
                        }
                        className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold mb-1.5 text-[#374151] dark:text-gray-200">
                        Time <span className="text-[#EF4444]">*</span>
                      </label>
                      <input
                        type="time"
                        required
                        value={eventFormData.time}
                        onChange={(e) =>
                          setEventFormData({ ...eventFormData, time: e.target.value })
                        }
                        className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                      />
                    </div>
                  </div>
                  
                  <div className="space-y-3 mt-2">
                    {new Date(eventFormData.date) < new Date() && (
                      <div className="p-3 bg-[#FAF8FF] border border-[#E5E7EB] rounded-md dark:bg-gray-700 dark:border-gray-600">
                        <ToggleSwitch
                          isOn={eventFormData.ignoreYear}
                          handleToggle={() =>
                            setEventFormData({
                              ...eventFormData,
                              ignoreYear: !eventFormData.ignoreYear,
                            })
                          }
                          label="Is this a recurring annual event?"
                        />
                      </div>
                    )}
                    
                    <div className="p-3 bg-[#FAF8FF] border border-[#E5E7EB] rounded-md dark:bg-gray-700 dark:border-gray-600">
                      <ToggleSwitch
                        isOn={eventFormData.public}
                        handleToggle={() =>
                          setEventFormData({
                            ...eventFormData,
                            public: !eventFormData.public,
                          })
                        }
                        label="Make this event public?"
                      />
                    </div>
                  </div>

                  <div className="flex justify-end gap-3 border-t border-[#E5E7EB] dark:border-gray-700 pt-4 mt-4">
                    <button
                      type="button"
                      onClick={() => setShowEventModal(false)}
                      className="px-4 py-2 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="px-5 py-2 bg-[#673AB7] text-white rounded-md hover:bg-[#5E35A6] shadow-md transition font-semibold text-sm"
                    >
                      Save Event
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Leave Application Modal */}
        {showLeaveModal && (
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md dark:bg-gray-800 border border-[#E5E7EB] dark:border-gray-700 overflow-hidden flex flex-col">
              <div className="flex justify-between items-center p-5 border-b border-[#E5E7EB] dark:border-gray-700 bg-[#FAF8FF] dark:bg-gray-800">
                <h2 className="text-lg sm:text-xl font-bold cfg-heading text-[#1F2937] dark:text-white">Apply for Leave</h2>
                <button 
                  onClick={() => setShowLeaveModal(false)}
                  className="text-[#6B7280] hover:text-[#EF4444] transition-colors"
                >
                  <FaTimes className="w-5 h-5" />
                </button>
              </div>
              
              <div className="p-5">
                <form onSubmit={handleLeaveSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
                      Leave Type
                    </label>
                    <select
                      name="leaveType"
                      value={leaveForm.leaveType}
                      onChange={handleLeaveFormChange}
                      className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                      required
                    >
                      {Object.keys(leaveTypes).map(type => (
                        <option key={type} value={type}>{type}</option>
                      ))}
                    </select>
                  </div>
                  
                  <div>
                    <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
                      From Date
                    </label>
                    <input
                      type="date"
                      name="fromDate"
                      value={leaveForm.fromDate}
                      onChange={handleLeaveFormChange}
                      className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                      required
                      min={new Date().toISOString().split('T')[0]}
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
                      To Date
                    </label>
                    <input
                      type="date"
                      name="toDate"
                      value={leaveForm.toDate}
                      onChange={handleLeaveFormChange}
                      className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                      required
                      min={leaveForm.fromDate}
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-semibold text-[#374151] dark:text-gray-200 mb-1.5">
                      Reason
                    </label>
                    <textarea
                      name="reason"
                      value={leaveForm.reason}
                      onChange={handleLeaveFormChange}
                      rows={3}
                      className="w-full p-2.5 text-sm border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white min-h-[80px]"
                      required
                    />
                  </div>
                  
                  <div className="pt-4 border-t border-[#E5E7EB] dark:border-gray-700 flex justify-end gap-3">
                    <button
                      type="button"
                      onClick={() => setShowLeaveModal(false)}
                      className="px-4 py-2 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="px-5 py-2 bg-[#673AB7] text-white rounded-md hover:bg-[#5E35A6] shadow-md transition font-semibold text-sm disabled:opacity-50"
                    >
                      {isLoading ? "Submitting..." : "Submit Leave"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        {deleteConfirm.show && (
          <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/50 p-4">
            <div className="bg-white w-full max-w-sm rounded-xl shadow-2xl p-6 relative dark:bg-gray-800 border border-[#E5E7EB] dark:border-gray-700 flex flex-col items-center">
              <div className="w-12 h-12 rounded-full bg-[#FEF2F2] dark:bg-red-900/30 flex items-center justify-center mb-4">
                <FaTrash className="text-[#EF4444] text-xl" />
              </div>
              <h2 className="text-xl font-bold cfg-heading text-[#1F2937] dark:text-white mb-2">
                Delete Confirmation
              </h2>
              <p className="text-[#6B7280] dark:text-gray-400 text-center mb-6 text-sm">
                Are you sure you want to delete this event? This action cannot be undone.
              </p>
              <div className="flex justify-center gap-3 w-full">
                <button
                  onClick={() => setDeleteConfirm({ show: false, eventId: null })}
                  className="flex-1 px-4 py-2 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                >
                  Cancel
                </button>
                <button
                  onClick={confirmDelete}
                  className="flex-1 px-4 py-2 bg-[#EF4444] text-white rounded-md hover:bg-[#B91C1C] shadow-md transition font-semibold text-sm"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Manage Emails Modal */}
        {showEmailModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/50 p-4">
            <div className="bg-white w-full max-w-md rounded-xl shadow-2xl relative dark:bg-gray-800 border border-[#E5E7EB] dark:border-gray-700 flex flex-col max-h-[90vh]">
              <div className="flex justify-between items-center p-5 border-b border-[#E5E7EB] dark:border-gray-700 bg-[#FAF8FF] dark:bg-gray-800 rounded-t-xl">
                <h2 className="text-lg sm:text-xl font-bold cfg-heading text-[#1F2937] dark:text-white truncate pr-4">
                  {selectedEventForEmail?.title ? `Emails for: ${selectedEventForEmail.title}` : 'Manage Emails'}
                </h2>
                <button
                  onClick={() => {
                    setShowEmailModal(false);
                    setSelectedEventIdForEmail(null);
                    setSelectedEventForEmail(null);
                    setEmails([""]);
                    setEmailErrors([]);
                  }}
                  className="text-[#6B7280] hover:text-[#EF4444] dark:text-gray-300 transition-colors"
                >
                  <FaTimes className="w-5 h-5" />
                </button>
              </div>
              
              <div className="p-5 overflow-y-auto scrollbar-thin scrollbar-thumb-[#E5E7EB] dark:scrollbar-thumb-gray-600">
                <div className="space-y-3 mb-5">
                  {emails.map((email, index) => (
                    <div key={index} className="space-y-1.5">
                      <div className="flex items-center gap-2">
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => handleEmailChange(e, index)}
                          className={`flex-1 p-2.5 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
                            emailErrors[index] ? "border-[#EF4444]" : "border-[#E5E7EB]"
                          }`}
                          placeholder="Enter email"
                        />
                        {emails.length > 1 && (
                          <button
                            type="button"
                            onClick={() => {
                              const newEmails = [...emails];
                              newEmails.splice(index, 1);
                              setEmails(newEmails);
                              
                              const newErrors = [...emailErrors];
                              newErrors.splice(index, 1);
                              setEmailErrors(newErrors);
                            }}
                            className="text-[#EF4444] hover:text-[#B91C1C] p-2.5 bg-[#FEF2F2] hover:bg-red-100 rounded-md dark:bg-red-900/30 dark:hover:bg-red-900/50 transition"
                            title="Remove email"
                          >
                            <FaTrash />
                          </button>
                        )}
                      </div>
                      {emailErrors[index] && (
                        <p className="text-[#EF4444] text-xs font-medium">{emailErrors[index]}</p>
                      )}
                    </div>
                  ))}
                </div>

                <div className="mb-6">
                  <button
                    type="button"
                    onClick={() => {
                      setEmails([...emails, ""]);
                      setEmailErrors([...emailErrors, ""]);
                    }}
                    className="flex items-center gap-1.5 px-3 py-1.5 bg-[#F3E8FF] text-[#673AB7] font-semibold text-sm rounded-md hover:bg-[#E9D5FF] dark:bg-purple-900/30 dark:text-purple-300 dark:hover:bg-purple-900/50 transition"
                  >
                    <FaPlusCircle /> Add Email
                  </button>
                </div>

                <div className="flex justify-end gap-3 border-t border-[#E5E7EB] dark:border-gray-700 pt-4">
                  <button
                    type="button"
                    onClick={() => {
                      setShowEmailModal(false);
                      setSelectedEventIdForEmail(null);
                      setSelectedEventForEmail(null);
                      setEmails([""]);
                      setEmailErrors([]);
                    }}
                    className="px-4 py-2 bg-[#F3F4F6] text-[#374151] border border-[#E5E7EB] rounded-md hover:bg-[#E5E7EB] transition font-semibold text-sm dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={sendEmail}
                    className="px-5 py-2 bg-[#10B981] text-white rounded-md hover:bg-[#059669] shadow-md transition font-semibold text-sm"
                  >
                    Save Emails
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}